// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/cta-bg1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/contact-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* Website Name: Pampas Fox
* Author: pampasfox
**/


/*--------------------------------------------------------------
# Set main reusable colors and fonts using CSS variables
# Learn more about CSS variables at https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_custom_properties
--------------------------------------------------------------*/
/* Fonts */
:root {
  --font-default: "Open Sans", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  
  --font-primary: "Montserrat", sans-serif;
  --font-secondary: "Raleway", sans-serif;
}



/* Smooth scroll behavior */
:root {
  scroll-behavior: smooth;
}

/* Colors */
:root {
--color-default: #2b180d;
  --color-primary: #155bd5;
  --color-secondary: #1b2f45;
 
  /* Home / Carousel Background Color */

  --primary: rgba(22, 52, 67, 0.726);
  /* --primary: #155bd5; */

  /* Home / Carousel Background Color */

  --primary-dark: #1c3ab6;
  --primary-light: #e2f1ff;
  --accent: #00d4d7;
  --accent-dark: #00bac1;
  --accent-light: #dff9f8;
  --success: #13d527;
  --success-dark: #00ae11;
  --success-light: #eafbe7;
  --secondary: #8f15d5;
  --secondary-dark: #6013c7;
  --secondary-light: #f4e5fa;
  --info: #15b2d5;
  --info-dark: #0f8ca8;
  --info-light: #e0f5fa;
  --caution: #dbbb25;
  --caution-dark: #d58f15;
  --caution-light: #fbf9e4;
  --error: #e6185e;
  --error-dark: #bf1257;
  --error-light: #fce4eb;
  --black: #1d1d1d;
  --dark-1: #2d2d2d;
  --dark-2: #4d4d4d;
  --dark-3: #6d6d6d;
  --gray-1: #8d8d8d;
  --gray-2: #adadad;
  --gray-3: #cdcdcd;
  --gray-4: #e0e0e0;
  --light-1: #efefef;
  --light-2: #f5f5f5;
  --light-3: #fafafa;
  --white: #ffffff;
   --color-white: #ffffff;
  --gradient-1: linear-gradient(180deg, #155bd5 0%, #1c3ab6 100%);
  --gradient-2: linear-gradient(180deg, #155bd5 13.02%, #00d4d7 85.42%);
  --gradient-3: linear-gradient(180deg, #155bd5 0%, #8f15d5 100%);
  --gradient-4: linear-gradient(180deg, #155bd5 0%, #13d527 100%);
  --gradient-5: linear-gradient(180deg, #155bd5 0%, #15bbd5 100%);
  --gradient-6: linear-gradient(180deg, #155bd5 0%, #dbbb25 100%);
  --gradient-7: linear-gradient(180deg, #155bd5 0%, #e6185e 100%);
  --gradient-8: linear-gradient(180deg, #1c3ab6 0%, #00bac1 100%);
  --gradient-9: linear-gradient(180deg, #00d4d7 13.02%, #155bd5 85.42%);
  --shadow-1: 0px 0px 1px rgba(40, 41, 61, 0.08),
    0px 0.5px 2px rgba(96, 97, 112, 0.16);
  --shadow-2: 0px 0px 1px rgba(40, 41, 61, 0.04),
    0px 2px 4px rgba(96, 97, 112, 0.16);
  --shadow-3: 0px 0px 2px rgba(40, 41, 61, 0.04),
    0px 4px 8px rgba(96, 97, 112, 0.16);
  --shadow-4: 0px 2px 4px rgba(40, 41, 61, 0.04),
    0px 8px 16px rgba(96, 97, 112, 0.16);
  --shadow-5: 0px 2px 8px rgba(40, 41, 61, 0.04),
    0px 16px 24px rgba(96, 97, 112, 0.16);
  --shadow-6: 0px 2px 8px rgba(40, 41, 61, 0.08),
    0px 20px 32px rgba(96, 97, 112, 0.24);
	
}

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: var(--font-default);
  color: var(--color-default);
}

a {
  color: var(--color-primary);
  text-decoration: none;
  transition: 0.3s;
}

a:hover {
  color: #82cbed;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--font-primary);
  color: var(--black)
}

p{color: var(--dark-3)}

.pointer {cursor:pointer}

.error { 
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

/*--------------------------------------------------------------
# Sections & Section Header
--------------------------------------------------------------*/
section {
  overflow: hidden;
  padding: 80px 0;
}

.section-header {
  text-align: center;
  padding-bottom: 30px;
}

.section-header h2 {
  /*font-size: 32px;*/
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 20px;
  position: relative;
}

.section-header h2:after {
  content: "";
  position: absolute;
  display: block;
  width: 60px;
  height: 2px;
  background: var(--color-primary);
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.section-header p {
  margin-bottom: 0;
}

  .light-bg{ background:#f5f5f5;}
  
/* ===== Buttons Css ===== */
.primary-btn {
  background: var(--primary);
  color: var(--white);
  box-shadow: var(--shadow-2);
}
.active.primary-btn, .primary-btn:hover, .primary-btn:focus {
  background: var(--primary-dark);
  color: var(--white);
  box-shadow: var(--shadow-4);
}
.deactive.primary-btn {
  background: var(--gray-4);
  color: var(--dark-3);
  pointer-events: none;
}

.primary-btn-outline {
  border-color: var(--primary);
  color: var(--primary);
}
.active.primary-btn-outline, .primary-btn-outline:hover, .primary-btn-outline:focus {
  background: var(--primary-dark);
  color: var(--white);
}
.deactive.primary-btn-outline {
  color: var(--dark-3);
  border-color: var(--gray-4);
  pointer-events: none;
}

.btn-get-started {
	font-family: var(--primary);    
	font-weight: bold;
	font-size: 16px;
	line-height: 20px;
	text-align: center;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	padding: 12px 24px;
	border-radius: 4px;
	letter-spacing: 1px;
	display: inline-block;  
	transition: 0.5s;
	color: var(--color-white);
	background: var(--color-primary);
	border: 1px solid transparent;
}

/* Justified Text Container */
.justified-text-container p {
  text-align: justify;
}

/* Justified Heading Container */
.justified-heading {
  text-align: justify;
}

/*--------------------------------------------------------------
# Breadcrumbs
--------------------------------------------------------------*/
.breadcrumbs {
  padding: 140px 0 60px 0;
  min-height: 30vh;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.breadcrumbs:before {
  content: "";
  /* background-color: rgba(21, 91, 213, 0.9); */
  background-color: rgba(22, 52, 67, 0.726);  
  position: absolute;
  inset: 0;
}

.breadcrumbs h2 {
  font-size: 56px;
  font-weight: 500;
  color: #fff;
  font-family: var(--font-secondary);
}

.breadcrumbs ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0 0 10px 0;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255,255,255,0.5);
}

.breadcrumbs ol a {
  color: rgba(255, 255, 255, 1);
  transition: 0.3s;
}

.breadcrumbs ol a:hover {
  text-decoration: underline;
}

.breadcrumbs ol li+li {
  padding-left: 10px;
}

.breadcrumbs ol li+li::before {
  display: inline-block;
  padding-right: 10px;
  color: #fff;
  content: "/";
}

/*--------------------------------------------------------------
# Scroll top button
--------------------------------------------------------------*/
.scroll-top {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: 15px;
  z-index: 99999;
  background: var(--color-primary);
  width: 40px;
  height: 40px;
  border-radius: 4px;
  transition: all 0.4s;
}

.scroll-top i {
  font-size: 24px;
  color: #fff;
  line-height: 0;
}

.scroll-top:hover {
  background: rgba(86, 184, 230, 0.8);
  color: #fff;
}

.scroll-top.active {
  visibility: visible;
  opacity: 1;
}

/*--------------------------------------------------------------
# Preloader
--------------------------------------------------------------*/
#preloader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  overflow: hidden;
  background: #fff;
  transition: all 0.6s ease-out;
}

#preloader:before {
  content: "";
  position: fixed;
  top: calc(50% - 30px);
  left: calc(50% - 30px);
  border: 6px solid var(--color-primary);
  border-top-color: #fff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: animate-preloader 1s linear infinite;
}

@keyframes animate-preloader {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/*--------------------------------------------------------------
# Disable aos animation delay on mobile devices
--------------------------------------------------------------*/
@media screen and (max-width: 768px) {
  [data-aos-delay] {
    transition-delay: 0 !important;
  }
}

/*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/
.header {
  transition: all 0.5s;
  z-index: 997;
  padding: 24px 0;
}

@media (max-width: 1200px) {
  .header {
    padding: 12px 0;
  }
}

.header.sticked {
  background: var(--primary);
  padding: 12px 0;
}

.header .logo img {
  /*max-height: 40px;*/
  margin-right: 6px;
}

.header .logo h1 {
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  font-family: var(--font-secondary);
  margin: 0;
}

/*--------------------------------------------------------------
# Desktop Navigation
--------------------------------------------------------------*/
@media (min-width: 1280px) {
  .navbar {
    padding: 0;
  }

  .navbar ul {
    margin: 0;
    padding: 0;
    display: flex;
    list-style: none;
    align-items: center;
  }

  .navbar li {
    position: relative;
  }

  .navbar a,
  .navbar a:focus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0 15px 30px;
    font-family: var(--font-default);
    font-size: 1em;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.6);
    white-space: nowrap;
    transition: 0.3s;
  }

  .navbar a i,
  .navbar a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
  }

  .navbar a:hover,
  .navbar .active,
  .navbar .active:focus,
  .navbar li:hover>a {
    color: #fff;
  }

  .navbar .dropdown ul {
    display: block;
    position: absolute;
    left: 14px;
    top: calc(100% + 30px);
    margin: 0;
    padding: 10px 0;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    background: #fff;
    box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
    transition: 0.2s;
  }

  .navbar .dropdown ul li {
    min-width: 200px;
  }

  .navbar .dropdown ul a {
    padding: 10px 20px;
    font-size: 15px;
    text-transform: none;
    color: var(--color-secondary);
  }

  .navbar .dropdown ul a i {
    font-size: 12px;
  }

  .navbar .dropdown ul a:hover,
  .navbar .dropdown ul .active:hover,
  .navbar .dropdown ul li:hover>a {
    color: var(--color-primary);
  }

  .navbar .dropdown:hover>ul {
    opacity: 1;
    top: 100%;
    visibility: visible;
  }

  .navbar .dropdown .dropdown ul {
    top: 0;
    left: calc(100% - 30px);
    visibility: hidden;
  }

  .navbar .dropdown .dropdown:hover>ul {
    opacity: 1;
    top: 0;
    left: 100%;
    visibility: visible;
  }
}

@media (min-width: 1280px) and (max-width: 1366px) {
  .navbar .dropdown .dropdown ul {
    left: -90%;
  }

  .navbar .dropdown .dropdown:hover>ul {
    left: -100%;
  }
}

@media (min-width: 1280px) {

  .mobile-nav-show,
  .mobile-nav-hide {
    display: none;
  }
}

/*--------------------------------------------------------------
# Mobile Navigation
--------------------------------------------------------------*/
@media (max-width: 1279px) {
  .navbar {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    max-width: 400px;
    bottom: 0;
    transition: 0.3s;
    z-index: 9997;
  }

  .navbar ul {
    position: absolute;
    inset: 0;
    padding: 50px 0 10px 0;
    margin: 0;
    /* background: rgba(21, 91, 213, 0.9); */
    background-color: rgba(22, 52, 67, 0.726);  
    overflow-y: auto;
    transition: 0.3s;
    z-index: 9998;
  }

  .navbar a,
  .navbar a:focus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    font-family: var(--font-default);
    /*font-size: 15px;*/
    font-weight: 600;
    color: rgba(255, 255, 255, 0.7);
    white-space: nowrap;
    transition: 0.3s;
  }

  .navbar a i,
  .navbar a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
  }

  .navbar a:hover,
  .navbar .active,
  .navbar .active:focus,
  .navbar li:hover>a {
    color: #fff;
  }

  .navbar .dropdown ul,
  .navbar .dropdown .dropdown ul {
    position: static;
    display: none;
    padding: 10px 0;
    margin: 10px 20px;
    background-color: rgba(20, 35, 51, 0.6);
  }

  .navbar .dropdown>.dropdown-active,
  .navbar .dropdown .dropdown>.dropdown-active {
    display: block;
  }

  .mobile-nav-show {
    color: rgba(255, 255, 255, 0.9);
    font-size: 28px;
    cursor: pointer;
    line-height: 0;
    transition: 0.5s;
  }

  .mobile-nav-hide {
    color: rgba(255, 255, 255, 0.9);
    font-size: 32px;
    cursor: pointer;
    line-height: 0;
    transition: 0.5s;
    position: fixed;
    right: 15px;
    top: 35px;
    z-index: 9999;
  }

  .mobile-nav-active {
    overflow: hidden;
  }

  .mobile-nav-active .navbar {
    right: 0;
  }

  .mobile-nav-active .navbar:before {
    content: "";
    position: fixed;
    inset: 0;
    background: rgba(27, 47, 69, 0.7);
    z-index: 9996;
  }
}

/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/

.hero {
position: relative;
    padding: 200px 0 100px 0;
    background: var(--primary);
}

.hero .shape {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 350px;
	
}


/*.hero {
  width: 100%;
  min-height: 100vh;
  background: url("../images/hero-bg.jpg") top center;
  background-size: cover;
  position: relative;
  padding: 150px 0 120px;
  z-index: 3;
}

@media (min-width: 1034px) {
  .hero:after {
    position: absolute;
    content: "";
    width: 40%;
    background: var(--color-primary);
    top: 0;
    bottom: 0;
  }
}

.hero:before {
  position: absolute;
  content: "";
  /*background: rgba(27, 47, 69, 0.6);*/
   /*background: #155bd5;
  inset: 0;
}*/

/*@media (max-width: 1034px) {
  .hero:before {
    background: rgba(27, 47, 69, 0.7);
  }
}*/

.hero .container {
  z-index: 1;
}

@media (min-width: 1365px) {
  .hero {
    background-attachment: fixed;
  }
}

.hero h2 {
  /*margin: 0;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  color: #fff;
  font-family: var(--font-secondary);
  */
  font-size: 2.75em;
    line-height: 1.25;
  font-weight: 700;
    color: var(--white);
    text-shadow: 0px 3px 8px #00000017;
    text-transform: capitalize;
}

.hero blockquote {
  
  padding-left: 20px;   
  border-left: 2px solid rgba(255,255,255,.7);
  margin: 40px 0;
   
}

.hero p {  
    color: var(--white);
    opacity: 0.7;
}

.hero .btn-get-started {
  font-family: var(--primary);    
  font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 12px 24px;
    border-radius: 4px;
  letter-spacing: 1px;
  display: inline-block;  
  transition: 0.5s;
  color: var(--color-primary);
  background: var(--color-white);
  border: 1px solid transparent;
  z-index:1000;

}


.hero .btn-get-started:hover {
	
	background: transparent;
	color: var(--white);
	border-color: var(--white);

}


.hero .btn-watch-video {
	z-index:1000;
  font-size: 16px;
  transition: 0.5s;
  margin-left: 25px;
  color: var(--white);
  font-weight: 600;
}

.hero .btn-watch-video i {
  color: var(--color-white);
  font-size: 32px;
  transition: 0.3s;
  line-height: 0;
  margin-right: 8px;
}

.hero .btn-watch-video:hover {
  color: #fff;
}

.hero .btn-watch-video:hover i {
  color: #fff;
}


.hero .header-image img {
    width: 100%;
    border-radius: 20px 20px 0px 0px;	
    }

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .hero .header-image {
    display: none;
  }
  
  .hero .shape {
    height: 100px;
  }
}




@media (max-width: 640px) {
  .hero h2 {
    font-size: 30px;
    line-height: 42px;
  }
  
  .hero {    
    padding: 100px 0 60px 0;
   
}


 .hero .header-image {
    margin-top: 40px;
}

  .hero .btn-get-started,
  .hero .btn-watch-video {
    font-size: 13px;
  }
}


.carousel-indicators [data-bs-target] {  
   /* background-color: #155bd5; */
  background-color: rgba(22, 52, 67, 0.726);     
   }


.carousel-indicators {   
    bottom: -25px;
}
	
/*.header-image img{
	-webkit-clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
-clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);

}*/

/*--------------------------------------------------------------
# Why Choose Us Section
--------------------------------------------------------------*/
.why-us {
  padding-bottom: 0;
}

.why-us .img-bg {
  min-height: 500px;
  background-size: cover;
}

.why-us .slides {
  background-color: #f7f9fc;
}

.why-us h3 {
  font-size: 24px;
  font-weight: 700;
  color: var(--color-secondary);
}

.why-us h4 {
  font-size: 18px;
  font-weight: 400;
  color: #29486a;
  font-family: var(--font-secondary);
}

.why-us .swiper {
  margin: 140px 140px 120px 140px;
  overflow: hidden;
}

.why-us .swiper-button-prev:after,
.why-us .swiper-button-next:after {
  font-size: 24px;
  color: var(--color-secondary);
}

.why-us .swiper-button-prev {
  left: 80px;
}

.why-us .swiper-button-next {
  right: 80px;
}

.why-us .swiper-pagination {
  margin-top: 30px;
  position: relative;
}

.why-us .swiper-pagination .swiper-pagination-bullet {
  background-color: var(--color-secondary);
}

.why-us .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--color-primary);
}

@media (max-width: 1200px) {
  .why-us .swiper {
    margin: 60px 60px 40px 60px;
  }

  .why-us .swiper-button-prev,
  .why-us .swiper-button-next {
    display: none;
  }
}

@media (max-width: 575px) {
  .why-us .swiper {
    margin: 40px 40px 20px 40px;
  }
}

.page-about .why-us {
  padding: 0 0 80px 0;
}

/*--------------------------------------------------------------
# About Section
--------------------------------------------------------------*/
.about .content h3 {
  font-weight: 700;
  font-size: 36px;
  font-family: var(--font-secondary);
  color: var(--color-secondary);
}

.about .content p {
  margin: 30px 0;
  color: #29486a;
}

.about .content ul {
  list-style: none;
  padding: 0;
}

.about .content ul li {
  padding: 0 0 15px 26px;
  position: relative;
  font-size: 15px;
  font-weight: 600;
}

.about .content ul i {
  position: absolute;
  font-size: 20px;
  left: 0;
  top: -3px;
  color: var(--color-primary);
}

/*--------------------------------------------------------------
# Services List Section
--------------------------------------------------------------*/

/*.services-list {
	background:var(--white)
}*/

.services-list .service-item {
  position: relative;    
}

.services-list .service-item .icon i {
  font-size: 40px;
  line-height: 0;
  margin-right: 20px; 
}

.services-list .service-item .title {
  font-weight: 700;
  margin: 8px 0;
  font-size: 24px;
}

.services-list .service-item .title a {
  color: var(--color-black);
}

.services-list .service-item .title a:hover {
  color: var(--color-primary);
}

.services-list .service-item .description {
  line-height: 1.5;
  /* font-size: 1.15rem; */
  font-size: 1.10rem;
}

.section-header p{font-size:18px; margin-bottom:25px;}

.services-list  .single-service {
  position: relative;
  text-align: left;
  padding: 30px;
  box-shadow: var(--shadow-2);
  border-radius: 5px;
  border: 1px solid var(--gray-4);
  background-color: var(--white);
  overflow: hidden;
  /*margin-top: 30px;*/
  transition: all 0.3s ease-out 0s;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .services-list  .single-service {
    padding: 40px;
  }
}
@media (max-width: 767px) {
  .services-list  .single-service {
    padding: 35px;
  }
}
.services-list .single-service::before {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 4px;
  width: 0%;
  content: "";
  background-color: var(--primary);
  transition: all 0.4s ease-in-out;
}
.services-list .single-service:hover {
  box-shadow: var(--shadow-4);
}
.services-list .single-service:hover::before {
  width: 100%;
}
.services-list .single-service .serial {
  font-size: 45px;
  display: block;
  margin-bottom: 7px;
  -webkit-text-stroke-width: 1px;
  /*-webkit-text-fill-color: transparent;*/
  /*-webkit-text-stroke-color: var(--primary);*/
  font-weight: 800;
  transition: all 0.3s ease-out 0s;
}
.services-list .single-service:hover .serial {
  -webkit-text-stroke-color: transparent;
  -webkit-text-fill-color: var(--primary);
}
.services-list .single-service h3 {
  color: var(--black);
  font-weight: 600;
}
.services-list .single-service p {
  color: var(--dark-3) !important;
  margin-top: 8px;
}
.services-list .single-service .light-rounded-buttons {
  margin-top: 25px;
}

/*--------------------------------------------------------------
# Call To Action Section
--------------------------------------------------------------*/

.facts {
 /* background: linear-gradient(rgba(21 91 213 / 80%), rgba(21 91 213 / 100%)), url("./images/cta-bg1.jpg") center center; */
 background: linear-gradient(hsla(210, 1%, 35%, 0.958), rgba(21 91 213 / 80%)), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center;
  background-size: cover;
  padding: 100px 0; 
}

@media (min-width: 1365px) {
  .facts {
    background-attachment: fixed;
  }
}

/*.call-to-action h3 {
  color: #fff;
  font-size: 28px;
  margin-bottom: 25px;
  font-weight: 700;  
}*/
.facts h3 {
	color: #fff;
	/*font-size: 28px;*/
	margin-bottom: 6px;
	font-weight: 400;
}

.facts p {
  color: #9ccff7;
  margin-bottom: 25px;
  font-size:18px;
  
}


#facts .section-header h2:after {    
background: var(--color-white);}   


.facts .cta-btn {
  font-family: var(--font-default);
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 12px 40px;
  border-radius: 50px;
  transition: 0.5s;
  margin: 10px;
  color: #fff;
  background: #2aa5df;
}

.facts .cta-btn:hover {
  background: var(--color-primary);
}

.facts .container {
  position: relative;
  z-index: 10;
}

.facts .counters span { 
  font-weight: 800;
  font-size: 68px;
  display: block;
  color: #fff;
}

.facts .counters p {
  padding: 0;
  margin: 0 0 10px 0;
  font-size: 18px;
  font-weight:400;
  color: #9ccff7;
}

.facts .facts-img {
  text-align: center;
  padding-top: 20px;
}

.facts .fct-title {
    color: #fff;
    font-size: 28px;
    font-weight: 700;
}
/*--------------------------------------------------------------
# Features Section
--------------------------------------------------------------*/
.features {
  padding-bottom: 0;
  background: var(--light-2);
}

.features h3 {
  color: var(--color-secondary);
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 30px;
}

.features .icon-list i {
  margin-right: 10px;
  font-size: 24px;
  line-height: 1.2;
}

.features .icon-list span {
  font-size: 18px;
  color: #29486a;
}

.features .phone-wrap {
  position: absolute;
  right: 0;
}

@media (max-width: 768px) {
  .features .phone-wrap {
    position: relative;
  }
}

.features .phone-wrap img {
  min-width: 340px;
}

@media (max-width: 992px) {
  .features .phone-wrap img {
    margin-top: 30px;
  }
}

@media (max-width: 768px) {
  .features .phone-wrap img {
    width: 100%;
  }
  .features .details {  
   padding: 0px 0px 50px 0px !important; 
}
}

.features .details {
  margin-top: 0px;
  /*padding: 120px 0; */
   padding: 0px 0px 100px 0px; 
}

.features .details h2 { 
  font-weight: 600;
  margin-bottom: 20px;
}

.features .details p {
  margin-bottom: 20px;
  font-size: 15px;
}


.features .details .btn-get-started {
  font-family: var(--primary);    
  font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 12px 24px;
    border-radius: 4px;
  letter-spacing: 1px;
  display: inline-block;  
  transition: 0.5s;
  color: var(--color-white);
  background: var(--color-primary);
  border: 1px solid transparent;

}




.features .details .btn-get-started:hover {
	background: transparent;
	color: var(--primary);
	border-color: var(--color-primary);

}


/*--------------------------------------------------------------
# Recent Blog Posts Section
--------------------------------------------------------------*/
.recent-posts .post-box {
  transition: 0.3s;
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.recent-posts .post-box .post-img {
  overflow: hidden;
  position: relative;
}

.recent-posts .post-box .post-img img {
  transition: 0.5s;
}

.recent-posts .post-box .meta {
  margin-top: 15px;
}

.recent-posts .post-box .meta .post-date {
  font-size: 15px;
  font-weight: 400;
  color: var(--color-primary);
}

.recent-posts .post-box .meta .post-author {
  font-size: 15px;
  font-weight: 400;
  color: var(--color-secondary);
}

.recent-posts .post-box .post-title {
  font-size: 18px;
  color: var(--color-secondary);
  font-weight: 700;
  margin: 15px 0 0 0;
  position: relative;
  transition: 0.3s;
}

.recent-posts .post-box p {
  margin: 15px 0 0 0;
  color: rgba(27, 47, 69, 0.7);
}

.recent-posts .post-box .readmore {
  display: flex;
  align-items: center;
  font-weight: 600;
  line-height: 1;
  transition: 0.3s;
  margin-top: 15px;
}

.recent-posts .post-box .readmore i {
  line-height: 0;
  margin-left: 4px;
  font-size: 18px;
}

.recent-posts .post-box:hover .post-title {
  color: var(--color-primary);
}

.recent-posts .post-box:hover .post-img img {
  transform: scale(1.1);
}

/*--------------------------------------------------------------
# Team Section
--------------------------------------------------------------*/
.team .team-member {
  overflow: hidden;
  background: #fff;
}

.team .team-member .member-img {
  position: relative;
  overflow: hidden;
}

.team .team-member .social {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 40px;
  opacity: 0;
  transition: ease-in-out 0.3s;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}

.team .team-member .social a {
  transition: color 0.3s;
  color: #31547c;
  margin: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.team .team-member .social a i {
  line-height: 0;
}

.team .team-member .social a:hover {
  color: var(--color-primary);
}

.team .team-member .social i {
  font-size: 18px;
  margin: 0 2px;
}

.team .team-member .member-info {
  padding: 25px 15px 0 15px;
  text-align: center;
}

.team .team-member .member-info h4 {
  font-weight: 700;
  margin-bottom: 5px;
  font-size: 18px;
  color: var(--color-secondary);
}

.team .team-member .member-info span {
  display: block;
  font-size: 13px;
  font-weight: 400;
  color: #6c757d;
}

.team .team-member .member-info p {
  font-style: italic;
  font-size: 14px;
  line-height: 26px;
  color: #6c757d;
}

.team .team-member:hover .social {
  opacity: 1;
}

/*--------------------------------------------------------------
# Services Cards Section
--------------------------------------------------------------*/
.services-cards {
  background: #f7f9fc;
}

.services-cards .card-item {
  border: 1px solid rgba(27, 47, 69, 0.1);
  background: #fff;
  position: relative;
  border-radius: 0;
}

.services-cards .card-item .card-bg {
  min-height: 270px;
  background-size: cover;
  background-repeat: no-repeat;
}

.services-cards .card-item .card-body {
  padding: 30px;
}

.services-cards .card-item h4 {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 15px;
  color: var(--color-secondary);
}

.services-cards .card-item p {
  color: var(--color-secondary);
  margin: 0;
}



/*--------------------------------------------------------------
# Cource Details
--------------------------------------------------------------*/
.course-details h3 {
  font-size: 24px;
  margin: 30px 0 15px 0;
  font-weight: 700;
  position: relative;
  padding-bottom: 10px;
}

.course-details h3:before {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 1px;
  background: #eef0ef;
  bottom: 0;
  left: 0;
}

.course-details h3:after {
  content: "";
  position: absolute;
  display: block;
  width: 60px;
  height: 1px;
  background: #5fcf80;
  bottom: 0;
  left: 0;
}

.course-details .course-info {
  background: #f6f7f6;
  padding: 10px 15px;
  margin-bottom: 15px;
}

.course-details .course-info h5 {
  font-weight: 400;
  font-size: 16px;
  margin: 0;
  font-family: "Poppins", sans-serif;
}

.course-details .course-info p {
  margin: 0;
  font-weight: 600;
}

.course-details .course-info a {
  color: #657a6d;
}

/*--------------------------------------------------------------
# Cource Details Tabs
--------------------------------------------------------------*/
.cource-details-tabs {
  overflow: hidden;
  padding-top: 0;
}

.cource-details-tabs .nav-tabs {
  border: 0;
}

.cource-details-tabs .nav-link {
  border: 0;
  padding: 12px 15px 12px 0;
  transition: 0.3s;
  color: #37423b;
  border-radius: 0;
  border-right: 2px solid #e2e7e4;
  font-weight: 600;
  font-size: 15px;
}

.cource-details-tabs .nav-link:hover {
  color: #5fcf80;
}

.cource-details-tabs .nav-link.active {
  color: #5fcf80;
  border-color: #5fcf80;
}

.cource-details-tabs .tab-pane.active {
  animation: fadeIn 0.5s ease-out;
}

.cource-details-tabs .details h3 {
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #37423b;
}

.cource-details-tabs .details p {
  color: #777777;
}

.cource-details-tabs .details p:last-child {
  margin-bottom: 0;
}

@media (max-width: 992px) {
  .cource-details-tabs .nav-link {
    border: 0;
    padding: 15px;
  }

  .cource-details-tabs .nav-link.active {
    color: #fff;
    background: #5fcf80;
  }
}

/*--------------------------------------------------------------
# Testimonials Section
--------------------------------------------------------------*/
.testimonials .testimonial-item {
  box-sizing: content-box;
  padding: 30px;
  margin: 40px 30px;
  box-shadow: 0px 0 20px rgba(27, 47, 69, 0.1);
  background: #fff;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  text-align: center;
  transition: 0.3s;
}

.testimonials .testimonial-item .stars {
  margin-bottom: 15px;
}

.testimonials .testimonial-item .stars i {
  color: #ffc107;
  margin: 0 1px;
}

.testimonials .testimonial-item .testimonial-img {
  width: 90px;
  border-radius: 50%;
  border: 4px solid #fff;
  margin: 0 auto;
}

.testimonials .testimonial-item h3 {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 5px 0;
  color: #111;
}

.testimonials .testimonial-item h4 {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.testimonials .testimonial-item p {
  font-style: italic;
  margin: 0 auto 15px auto;
}

.testimonials .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

.testimonials .swiper-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background-color: #e8eff6;
  opacity: 1;
}

.testimonials .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--color-primary);
}

.testimonials .swiper-slide {
  opacity: 0.3;
}

@media (max-width: 1199px) {
  .testimonials .swiper-slide-active {
    opacity: 1;
  }

  .testimonials .swiper-pagination {
    margin-top: 0;
  }

  .testimonials .testimonial-item {
    margin: 40px 20px;
  }
}

@media (min-width: 1200px) {
  .testimonials .swiper-slide-next {
    opacity: 1;
    transform: scale(1.12);
  }
}

/*--------------------------------------------------------------
# Portfolio Section
--------------------------------------------------------------*/
.portfolio .portfolio-flters {
  padding: 0;
  margin: 0 auto 30px auto;
  list-style: none;
  text-align: center;
}

.portfolio .portfolio-flters li {
  color: var(--color-secondary);
  cursor: pointer;
  display: inline-block;
  padding: 0;
  font-size: 18px;
  font-weight: 400;
  margin: 0 10px;
  line-height: 1;
  margin-bottom: 5px;
  transition: all 0.3s ease-in-out;
}

.portfolio .portfolio-flters li:hover,
.portfolio .portfolio-flters li.filter-active {
  color: var(--color-primary);
}

.portfolio .portfolio-flters li:first-child {
  margin-left: 0;
}

.portfolio .portfolio-flters li:last-child {
  margin-right: 0;
}

@media (max-width: 575px) {
  .portfolio .portfolio-flters li {
    font-size: 14px;
    margin: 0 5px;
  }
}

.portfolio .portfolio-item {
  position: relative;
}

.portfolio .portfolio-item .portfolio-info {
  opacity: 0;
  position: absolute;
  left: 30px;
  right: 30px;
  bottom: 0;
  z-index: 3;
  transition: all ease-in-out 0.3s;
  background: rgba(255, 255, 255, 0.9);
  padding: 15px;
}

.portfolio .portfolio-item .portfolio-info h4 {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-default);
  padding-right: 50px;
}

.portfolio .portfolio-item .portfolio-info p {
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 0;
  padding-right: 50px;
}

.portfolio .portfolio-item .portfolio-info .preview-link,
.portfolio .portfolio-item .portfolio-info .details-link {
  position: absolute;
  right: 50px;
  font-size: 24px;
  top: calc(50% - 14px);
  color: rgba(27, 47, 69, 0.7);
  transition: 0.3s;
  line-height: 0;
}

.portfolio .portfolio-item .portfolio-info .preview-link:hover,
.portfolio .portfolio-item .portfolio-info .details-link:hover {
  color: var(--color-primary);
}

.portfolio .portfolio-item .portfolio-info .details-link {
  right: 14px;
  font-size: 28px;
}

.portfolio .portfolio-item:hover .portfolio-info {
  opacity: 1;
  bottom: 20px;
}

/*--------------------------------------------------------------
# Portfolio Details
--------------------------------------------------------------*/
.portfolio-details .portfolio-details-slider img {
  width: 100%;
}

.portfolio-details .portfolio-details-slider .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #fff;
  opacity: 1;
  border: 1px solid var(--color-primary);
}

.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--color-primary);
}

.portfolio-details .portfolio-info {
  padding: 30px;
  box-shadow: 0px 0 30px rgba(27, 47, 69, 0.1);
}

.portfolio-details .portfolio-info h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #d6e2ef;
}

.portfolio-details .portfolio-info ul {
  list-style: none;
  padding: 0;
  font-size: 15px;
}

.portfolio-details .portfolio-info ul li+li {
  margin-top: 10px;
}

/*.portfolio-details .portfolio-description {
 *padding-top: 30px;*
}*/

.portfolio-details .portfolio-description h2 {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--color-secondary);
}

.portfolio-details .portfolio-description p {
  padding: 0;
}

/*--------------------------------------------------------------
# Contact Section
--------------------------------------------------------------*/
.contact {
 background: #f5f5f5 url(${___CSS_LOADER_URL_REPLACEMENT_1___}) left top no-repeat;
  background-size: contain;
  position: relative;
  
  
}

@media (max-width: 640px) {
  .contact {
    background-position: center 50px;
  }
}

.contact:before {
  content: "";
  background: rgba(255, 255, 255, 0.7);
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
}

.contact .info-item+.info-item {
  margin-top: 40px;
}

.contact .info-item i {
  font-size: 20px;
  background: var(--color-primary);
  color: #fff;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  transition: all 0.3s ease-in-out;
  margin-right: 15px;
}

.contact .info-item h4 {
  padding: 0;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #1c88ba;
}

.contact .info-item p {
  padding: 0;
  margin-bottom: 0;
  font-size: 14px;
}

.contact .php-email-form {
  width: 100%;
}

.contact .php-email-form .form-group {
  padding-bottom: 8px;
}

.contact .php-email-form .error-message {
  display: none;
  color: #fff;
  background: #df1529;
  text-align: left;
  padding: 15px;
  font-weight: 600;
}

.contact .php-email-form .error-message br+br {
  margin-top: 25px;
}

.contact .php-email-form .sent-message {
  display: none;
  color: #fff;
  background: #059652;
  text-align: center;
  padding: 15px;
  font-weight: 600;
}

.contact .php-email-form .loading {
  display: none;
  background: #fff;
  text-align: center;
  padding: 15px;
}

.contact .php-email-form .loading:before {
  content: "";
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin: 0 10px -6px 0;
  border: 3px solid #059652;
  border-top-color: #fff;
  animation: animate-loading 1s linear infinite;
}

.contact .php-email-form input,
.contact .php-email-form textarea {
  border-radius: 0;
  box-shadow: none;
  font-size: 14px;
  padding: 12px 15px;
}

.contact .php-email-form input:focus,
.contact .php-email-form textarea:focus {
  border-color: var(--color-primary);
}

.contact .php-email-form textarea {
  padding: 10px 12px;
}


.contact .php-email-form button[type=submit] {
  font-family: var(--primary);    
  font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 12px 24px;
    border-radius: 4px;
  letter-spacing: 1px;
  display: inline-block;  
  transition: 0.5s;
  color: var(--color-white);
  background: var(--color-primary);
  border: 1px solid transparent;

}

.contact .php-email-form button[type=submit]:hover {
	background: transparent;
	color: var(--primary);
	border-color: var(--color-primary);

}

@keyframes animate-loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/*--------------------------------------------------------------
# Blog Stylings
--------------------------------------------------------------*/
/*--------------------------------------------------------------
# Blog Home Posts List
--------------------------------------------------------------*/
.blog .posts-list article {
  height: 100%;
  border-bottom: 1px solid #d6e2ef;
  padding-bottom: 30px;
}

.blog .posts-list article+article {
  margin-top: 60px;
}

.blog .posts-list .post-img {
  max-height: 240px;
  overflow: hidden;
}

.blog .posts-list .title {
  font-size: 20px;
  font-weight: 600;
  padding: 0;
  margin: 20px 0 0 0;
}

.blog .posts-list .title a {
  color: var(--color-secondary);
  transition: 0.3s;
}

.blog .posts-list .title a:hover {
  color: var(--color-primary);
}

.blog .posts-list .meta-top {
  margin-top: 20px;
  color: #467ab3;
}

.blog .posts-list .meta-top ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  align-items: center;
  padding: 0;
  margin: 0;
}

.blog .posts-list .meta-top ul li+li {
  padding-left: 20px;
}

.blog .posts-list .meta-top i {
  font-size: 16px;
  margin-right: 8px;
  line-height: 0;
  color: rgba(86, 184, 230, 0.8);
}

.blog .posts-list .meta-top a {
  color: #467ab3;
  font-size: 14px;
  display: inline-block;
  line-height: 1;
}

.blog .posts-list .content {
  margin-top: 20px;
}

.blog .posts-list .read-more a {
  display: inline-block;
  color: #1f98d1;
  transition: 0.3s;
  font-size: 15px;
  font-weight: 500;
}

.blog .posts-list .read-more a:hover {
  color: var(--color-primary);
}

/*--------------------------------------------------------------
# Blog Details Page
--------------------------------------------------------------*/
.blog .blog-details {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.blog .blog-details .post-img {
  margin: -30px -30px 20px -30px;
  overflow: hidden;
}

.blog .blog-details .title {
  font-size: 28px;
  font-weight: 700;
  padding: 0;
  margin: 20px 0 0 0;
  color: var(--color-secondary);
}

.blog .blog-details .content {
  margin-top: 20px;
}

.blog .blog-details .content h3 {
  font-size: 22px;
  margin-top: 30px;
  font-weight: bold;
}

.blog .blog-details .content blockquote {
  overflow: hidden;
  background-color: rgba(27, 47, 69, 0.06);
  padding: 60px;
  position: relative;
  text-align: center;
  margin: 20px 0;
}

.blog .blog-details .content blockquote p {
  color: var(--color-default);
  line-height: 1.6;
  margin-bottom: 0;
  font-style: italic;
  font-weight: 500;
  font-size: 22px;
}

.blog .blog-details .content blockquote:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: var(--color-secondary);
  margin-top: 20px;
  margin-bottom: 20px;
}

.blog .blog-details .meta-top {
  margin-top: 20px;
  color: var(--color-gray);
}

.blog .blog-details .meta-top ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  align-items: center;
  padding: 0;
  margin: 0;
}

.blog .blog-details .meta-top ul li+li {
  padding-left: 20px;
}

.blog .blog-details .meta-top i {
  font-size: 16px;
  margin-right: 8px;
  line-height: 0;
  color: rgba(86, 184, 230, 0.8);
}

.blog .blog-details .meta-top a {
  color: var(--color-gray);
  font-size: 14px;
  display: inline-block;
  line-height: 1;
}

.blog .blog-details .meta-bottom {
  padding-top: 10px;
  border-top: 1px solid rgba(27, 47, 69, 0.15);
}

.blog .blog-details .meta-bottom i {
  color: #38618e;
  display: inline;
}

.blog .blog-details .meta-bottom a {
  color: rgba(27, 47, 69, 0.8);
  transition: 0.3s;
}

.blog .blog-details .meta-bottom a:hover {
  color: var(--color-primary);
}

.blog .blog-details .meta-bottom .cats {
  list-style: none;
  display: inline;
  padding: 0 20px 0 0;
  font-size: 14px;
}

.blog .blog-details .meta-bottom .cats li {
  display: inline-block;
}

.blog .blog-details .meta-bottom .tags {
  list-style: none;
  display: inline;
  padding: 0;
  font-size: 14px;
}

.blog .blog-details .meta-bottom .tags li {
  display: inline-block;
}

.blog .blog-details .meta-bottom .tags li+li::before {
  padding-right: 6px;
  color: var(--color-default);
  content: ",";
}

.blog .blog-details .meta-bottom .share {
  font-size: 16px;
}

.blog .blog-details .meta-bottom .share i {
  padding-left: 5px;
}

.blog .post-author {
  padding: 20px;
  margin-top: 30px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.blog .post-author img {
  max-width: 120px;
  margin-right: 20px;
}

.blog .post-author h4 {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 0px;
  padding: 0;
  color: var(--color-secondary);
}

.blog .post-author .social-links {
  margin: 0 10px 10px 0;
}

.blog .post-author .social-links a {
  color: rgba(27, 47, 69, 0.5);
  margin-right: 5px;
}

.blog .post-author p {
  font-style: italic;
  color: rgba(var(--color-gray-rgb), 0.8);
  margin-bottom: 0;
}


/*--------------------------------------------------------------
#.management
--------------------------------------------------------------*/
.management {
  background: var(--light-2);
}

.management .member {
  position: relative;
  box-shadow: 0px 2px 15px rgba(44, 73, 100, 0.08);
  padding: 20px;
  border-radius: 10px;
  background:#fff;  
}
 
@media screen and (min-width: 768px) {
  
  
}


@media screen and (max-width: 768px) {
  .management .member {
  margin:5px;
}
.management .member .member-info {
  padding-left: 0px !important;
}
.management .member {
    padding: 25px  10px!important;
  }
  
  
}

.management .member .pic {
  overflow: hidden;
  width: 150px;
  border-radius: 50%;
}

.management .member .pic img {
  transition: ease-in-out 0.3s;
}

.management .member:hover img {
  transform: scale(1.1);
}

.management .member .member-info {
  padding-left: 30px;
}

.management .member h4 {
  font-weight: 700;
  margin-bottom: 5px;
  font-size: 20px;
  color: #2c4964;
}

.management .member span {
  display: block;
  font-size: 15px;
  padding-bottom: 10px;
  position: relative;
  font-weight: 500;
}

.management .member span::after {
  content: "";
  position: absolute;
  display: block;
  width: 50px;
  height: 1px;
  background: var(--color-primary);
  bottom: 0;
  left: 0;
}

.management .member p {
  margin: 10px 0 0 0;
  font-size: 14px;
}

.management .member .social {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.management .member .social a {
  transition: ease-in-out 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  width: 32px;
  height: 32px;
  background: var(--color-primary);
}

.management .member .social a i {
  color: #fff;
  font-size: 16px;
  margin: 0 2px;
}

.management .member .social a:hover {
  background: #1977cc;
}

.management .member .social a+a {
  margin-left: 8px;
}


/*About us*/
.vision .card-body {padding-bottom:2rem}
.vision .card-body .card-title{margin-bottom:15px;}


.vision .card-body .card-title {
  display: block;  
  padding-bottom: 10px;
  position: relative;
  font-weight: 1000;
}

.vision .card-body .card-title::after {
  content: "";
  position: absolute;
  display: block;
  width: 50px;
  height: 2px;
  background: var(--color-primary);
  bottom: 0;
  left: 0;
}

/*--------------------------------------------------------------
# Blog Sidebar
--------------------------------------------------------------*/
.blog .sidebar .sidebar-title {
  font-size: 22px;
  font-weight: 400;
  padding: 0;
  margin: 0;
  color: var(--color-secondary);
}

.blog .sidebar .sidebar-item+.sidebar-item {
  margin-top: 40px;
}

.blog .sidebar .search-form form {
  background: #fff;
  border: 1px solid rgba(27, 47, 69, 0.2);
  padding: 3px 10px;
  position: relative;
}

.blog .sidebar .search-form form input[type=text] {
  border: 0;
  padding: 4px;
  border-radius: 4px;
  width: calc(100% - 40px);
}

.blog .sidebar .search-form form input[type=text]:focus {
  outline: none;
}

.blog .sidebar .search-form form button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border: 0;
  background: none;
  font-size: 16px;
  padding: 0 15px;
  margin: -1px;
  background: var(--color-primary);
  color: #fff;
  transition: 0.3s;
  border-radius: 0 4px 4px 0;
  line-height: 0;
}

.blog .sidebar .search-form form button i {
  line-height: 0;
}

.blog .sidebar .search-form form button:hover {
  background: rgba(86, 184, 230, 0.8);
}

.blog .sidebar .categories ul {
  list-style: none;
  padding: 0;
}

.blog .sidebar .categories ul li+li {
  padding-top: 10px;
}

.blog .sidebar .categories ul a {
  color: var(--color-secondary);
  font-size: 15px;
}

.blog .sidebar .categories ul a:hover {
  color: var(--color-default);
}

.blog .sidebar .categories ul a span {
  padding-left: 5px;
  color: rgba(var(--color-default-rgb), 0.4);
  font-size: 14px;
}

.blog .sidebar .recent-posts .post-item {
  display: flex;
  box-shadow: 0px 0 15px rgba(0, 0, 0, 0.08);
  padding: 20px;
}

.blog .sidebar .recent-posts .post-item+.post-item {
  margin-top: 15px;
}

.blog .sidebar .recent-posts img {
  width: 80px;
  margin-right: 15px;
}

.blog .sidebar .recent-posts h4 {
  font-size: 18px;
  font-weight: 400;
}

.blog .sidebar .recent-posts h4 a {
  color: var(--color-secondary);
  transition: 0.3s;
}

.blog .sidebar .recent-posts h4 a:hover {
  color: var(--color-primary);
}

.blog .sidebar .recent-posts time {
  display: block;
  font-style: italic;
  font-size: 14px;
  color: rgba(var(--color-default-rgb), 0.4);
}

.blog .sidebar .tags {
  margin-bottom: -10px;
}

.blog .sidebar .tags ul {
  list-style: none;
  padding: 0;
}

.blog .sidebar .tags ul li {
  display: inline-block;
}

.blog .sidebar .tags ul a {
  color: #38618e;
  font-size: 14px;
  padding: 6px 14px;
  margin: 0 6px 8px 0;
  border: 1px solid rgba(27, 47, 69, 0.15);
  display: inline-block;
  border-radius: 50px;
  transition: 0.3s;
}

.blog .sidebar .tags ul a:hover {
  color: #fff;
  border: 1px solid var(--color-primary);
  background: var(--color-primary);
}

.blog .sidebar .tags ul a span {
  padding-left: 5px;
  color: rgba(27, 47, 69, 0.8);
  font-size: 14px;
}

/*--------------------------------------------------------------
# Blog Comments
--------------------------------------------------------------*/
.blog .comments {
  margin-top: 30px;
}

.blog .comments .comments-count {
  font-weight: bold;
}

.blog .comments .comment {
  margin-top: 30px;
  position: relative;
}

.blog .comments .comment .comment-img {
  margin-right: 14px;
}

.blog .comments .comment .comment-img img {
  width: 60px;
}

.blog .comments .comment h5 {
  font-size: 16px;
  margin-bottom: 2px;
}

.blog .comments .comment h5 a {
  font-weight: bold;
  color: var(--color-default);
  transition: 0.3s;
}

.blog .comments .comment h5 a:hover {
  color: var(--color-primary);
}

.blog .comments .comment h5 .reply {
  padding-left: 10px;
  color: var(--color-secondary);
}

.blog .comments .comment h5 .reply i {
  font-size: 20px;
}

.blog .comments .comment time {
  display: block;
  font-size: 14px;
  color: rgba(27, 47, 69, 0.8);
  margin-bottom: 5px;
}

.blog .comments .comment.comment-reply {
  padding-left: 40px;
}

.blog .comments .reply-form {
  margin-top: 30px;
  padding: 30px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.blog .comments .reply-form h4 {
  font-weight: bold;
  font-size: 22px;
}

.blog .comments .reply-form p {
  font-size: 14px;
}

.blog .comments .reply-form input {
  border-radius: 4px;
  padding: 10px 10px;
  font-size: 14px;
}

.blog .comments .reply-form input:focus {
  box-shadow: none;
  border-color: rgba(86, 184, 230, 0.8);
}

.blog .comments .reply-form textarea {
  border-radius: 4px;
  padding: 10px 10px;
  font-size: 14px;
}

.blog .comments .reply-form textarea:focus {
  box-shadow: none;
  border-color: rgba(86, 184, 230, 0.8);
}

.blog .comments .reply-form .form-group {
  margin-bottom: 25px;
}

.blog .comments .reply-form .btn-primary {
  border-radius: 4px;
  padding: 10px 20px;
  border: 0;
  background-color: var(--color-secondary);
}

.blog .comments .reply-form .btn-primary:hover {
  background-color: rgba(27, 47, 69, 0.8);
}

/*--------------------------------------------------------------
# Blog Home Pagination
--------------------------------------------------------------*/
.blog .blog-pagination {
  margin-top: 30px;
  color: #38618e;
}

.blog .blog-pagination ul {
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
}

.blog .blog-pagination li {
  margin: 0 5px;
  transition: 0.3s;
}

.blog .blog-pagination li a {
  color: #2aa5df;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background: #dbf0fa;
  padding: 7px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.blog .blog-pagination li.active a,
.blog .blog-pagination li:hover a {
  background: var(--color-primary);
  color: #fff;
}

/*--------------------------------------------------------------
# Counts
--------------------------------------------------------------*/
.counts {
  padding-top: 80px;
}

.counts .count-box {
  padding: 30px 30px 25px 30px;
  width: 100%;
  position: relative;
  text-align: center;
  box-shadow: 0px 2px 35px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
}

.counts .count-box i {
  position: absolute;
  width: 54px;
  height: 54px;
  top: -27px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  background: #fff;
  color: #e03a3c;
  border-radius: 50px;
  border: 2px solid #fff;
  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.counts .count-box span {
  font-size: 36px;
  display: block;
  font-weight: 700;
  color: #111111;
}

.counts .count-box p {
  padding: 0;
  margin: 0;
  font-family: "Raleway", sans-serif;
  font-size: 14px;
}

/*--------------------------------------------------------------
# Clients Section
--------------------------------------------------------------*/
.clients {
  padding: 0 0 60px 0;
  /*background: var(--light-2);*/
   background: var(--white);
}

.clients .swiper-slide img {
  /*opacity: 0.5;*/
  transition: 0.3s;
  /*filter: grayscale(100); */

  background-color: var(--white);
padding:10px;  
  
  border-radius: 8px;
  transition: all 0.4s ease-out 0s;
  border: 1px solid #eee;
}





.clients .swiper-slide img:hover {
   box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.096);
  transform: translateY(-5px);
}
/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
.footer {
  font-size: 14px;
}

.footer .footer-content {
  background-color: var (--white);
  background-size: contain;
  padding: 60px 0 30px 0;
}

.footer .footer-content .footer-info {
  margin-bottom: 30px;
}

.footer .footer-content .footer-info .logo {
  line-height: 0;
  margin-bottom: 10px;
}

.footer .footer-content .footer-info .logo img {
  /*max-height: 40px;*/
   max-width: 140px;
  margin-right: 6px;
}

.footer .footer-content .footer-info .logo span {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--color-secondary);
  font-family: var(--font-secondary);
  margin-top: 3px;
}

.footer .footer-content .footer-info p {
  /* font-size: 15px; */
  font-size: 14px;
  margin-bottom: 0;
  font-family: var(--font-primary);
  color: var(--color-secondary);
}

.footer .footer-content .social-links a {
  font-size: 14px;
  line-height: 0;
  display: inline-block;
  width: 32px;
  height: 32px;
  color: rgba(27, 47, 69, 0.5);
  margin-right: 10px;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-primary);
  color: #fff;
  border-radius: 50px;
}

.footer .footer-content .social-links a:hover {
  background-color: #38618e;
}

.footer .footer-content h4 {
  font-size: 16px;
  font-weight: bold;
  color: var(--black);
  position: relative;
  padding-bottom: 12px;
}

.footer .footer-content .footer-links {
  margin-bottom: 30px;
}

.footer .footer-content .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer .footer-content .footer-links ul i {
  margin-right: 2px;
  color: var(--color-primary);
  font-size: 16px;
  line-height: 0;
}

.footer .footer-content .footer-links ul li {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.footer .footer-content .footer-links ul li:first-child {
  padding-top: 0;
}

.footer .footer-content .footer-links ul a {
  color: var(--dark-3);
  transition: 0.3s;
  display: inline-block;
  line-height: 1;

}

.footer .footer-content .footer-links ul a:hover {
  color: var(--color-primary);
}

.footer .footer-content .footer-contact p {
  line-height: 26px;
  color: var(--dark-3);
}

.footer .footer-legal {
 background: var(--light-2);
  padding: 30px 0;
}

.footer .footer-legal .copyright {
  text-align: center;
  color:  var(--dark-3);
}

.footer .footer-legal .credits {
  padding-top: 4px;
  text-align: center;
  font-size: 13px;
  color:  var(--dark-3);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE;;;AAGF;;;+DAG+D;AAC/D,UAAU;AACV;EACE,4NAA4N;;EAE5N,wCAAwC;EACxC,uCAAuC;AACzC;;;;AAIA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;AACA,wBAAwB;EACtB,wBAAwB;EACxB,0BAA0B;;EAE1B,qCAAqC;;EAErC,kCAAkC;EAClC,wBAAwB;;EAExB,qCAAqC;;EAErC,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;GACf,sBAAsB;EACvB,+DAA+D;EAC/D,qEAAqE;EACrE,+DAA+D;EAC/D,+DAA+D;EAC/D,+DAA+D;EAC/D,+DAA+D;EAC/D,+DAA+D;EAC/D,+DAA+D;EAC/D,qEAAqE;EACrE;yCACuC;EACvC;uCACqC;EACrC;uCACqC;EACrC;wCACsC;EACtC;yCACuC;EACvC;yCACuC;;AAEzC;;AAEA;;+DAE+D;AAC/D;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;EAME,gCAAgC;EAChC;AACF;;AAEA,EAAE,oBAAoB;;AAEtB,UAAU,cAAc;;AAExB;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;EAEE,WAAW,kBAAkB,CAAC;;AAEhC,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;CACC,2BAA2B;CAC3B,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB,yBAAyB;CACzB,gCAAgC;CAChC,6BAA6B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;;+DAE+D;AAC/D;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,yCAAyC;EACzC,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;EACtC,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EAEZ,+CAA+C;AACjD;;AAYA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;+DAE+D;AAC/D;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;;+DAE+D;AAC/D;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;EAClC,SAAS;AACX;;AAEA;;+DAE+D;AAC/D;EACE;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,gCAAgC;IAChC,cAAc;IACd,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,kDAAkD;IAClD,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,MAAM;IACN,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,MAAM;IACN,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;EAEE;;IAEE,aAAa;EACf;AACF;;AAEA;;+DAE+D;AAC/D;EACE;IACE,eAAe;IACf,MAAM;IACN,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,SAAS;IACT,wCAAwC;IACxC,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;;IAEE,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,uCAAuC;EACzC;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,SAAS;IACT,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,QAAQ;IACR,iCAAiC;IACjC,aAAa;EACf;AACF;;AAEA;;+DAE+D;;AAE/D;AACA,kBAAkB;IACd,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;;AAEjB;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;uCAwBuC;GACpC;;EAED;;AAEF;;;;EAIE;;AAEF;EACE,UAAU;AACZ;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;;;;;GAMC;EACD,iBAAiB;IACf,iBAAiB;EACnB,gBAAgB;IACd,mBAAmB;IACnB,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;;AAEhB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;;AAEd;;;AAGA;;CAEC,uBAAuB;CACvB,mBAAmB;CACnB,0BAA0B;;AAE3B;;;AAGA;CACC,YAAY;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;IACI,WAAW;IACX,gCAAgC;IAChC;;AAEJ;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;;;;AAKA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;;AAE3B;;;CAGC;IACG,gBAAgB;AACpB;;EAEE;;IAEE,eAAe;EACjB;AACF;;;AAGA;GACG,+BAA+B;EAChC,yCAAyC;GACxC;;;AAGH;IACI,aAAa;AACjB;;AAEA;;;;EAIE;;AAEF;;+DAE+D;AAC/D;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,OAAO;EACP,SAAS;EACT,2BAA2B;AAC7B;;AAEA;;+DAE+D;;AAE/D;;EAEE;;AAEF;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,kBAAkB,cAAc,EAAE,kBAAkB,CAAC;;AAErD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EAKpB,gCAAgC;AAClC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,wCAAwC;EACxC,6CAA6C;EAC7C,gBAAgB;EAKhB,gCAAgC;AAClC;AACA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;;+DAE+D;;AAE/D;CACC,2HAA2H;CAC3H,oIAAwH;EACvH,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;;;;;EAKE;AACF;CACC,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;;AAEhB;;;AAGA;AACA,8BAA8B,CAAC;;;AAG/B;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;;+DAE+D;AAC/D;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;GACC,oCAAoC;AACvC;AACA;;AAEA;EACE,eAAe;EACf,qBAAqB;GACpB,0BAA0B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,2BAA2B;EAC3B,iBAAiB;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;;AAE/B;;;;;AAKA;CACC,uBAAuB;CACvB,qBAAqB;CACrB,kCAAkC;;AAEnC;;;AAGA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;;+DAE+D;AAC/D;EACE,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;;;AAIA;;+DAE+D;AAC/D;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;;AAEF;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;;+DAE+D;AAC/D;CACC,8EAAqE;EACpE,wBAAwB;EACxB,kBAAkB;;;AAGpB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EAEtB,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,2BAA2B;EAC3B,iBAAiB;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;;AAE/B;;AAEA;CACC,uBAAuB;CACvB,qBAAqB;CACrB,kCAAkC;;AAEnC;;AAaA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;+DAE+D;AAC/D;;+DAE+D;AAC/D;EACE,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;+DAE+D;AAC/D;EACE,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;AAClB;;;AAGA;;+DAE+D;AAC/D;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;AAGA;;;AAGA;EACE;EACA,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;IACI,6BAA6B;EAC/B;;;AAGF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,WAAW;AACX,oBAAoB,mBAAmB;AACvC,+BAA+B,kBAAkB,CAAC;;;AAGlD;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,SAAS;EACT,OAAO;AACT;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,gCAAgC;EAChC,WAAW;AACb;;AAEA;;+DAE+D;AAC/D;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;EACE,mBAAmB;EACnB,8BAA8B;GAC7B,wBAAwB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;;EAE3B,8BAA8B;AAChC,YAAY;;EAEV,kBAAkB;EAKlB,gCAAgC;EAChC,sBAAsB;AACxB;;;;;;AAMA;GACG,8CAA8C;EAK/C,2BAA2B;AAC7B;AACA;;+DAE+D;AAC/D;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;GACnB,gBAAgB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;;AAEhB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;CACC,0BAA0B;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB","sourcesContent":["/**\n* Website Name: Pampas Fox\n* Author: pampasfox\n**/\n\n\n/*--------------------------------------------------------------\n# Set main reusable colors and fonts using CSS variables\n# Learn more about CSS variables at https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_custom_properties\n--------------------------------------------------------------*/\n/* Fonts */\n:root {\n  --font-default: \"Open Sans\", system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  \n  --font-primary: \"Montserrat\", sans-serif;\n  --font-secondary: \"Raleway\", sans-serif;\n}\n\n\n\n/* Smooth scroll behavior */\n:root {\n  scroll-behavior: smooth;\n}\n\n/* Colors */\n:root {\n--color-default: #2b180d;\n  --color-primary: #155bd5;\n  --color-secondary: #1b2f45;\n \n  /* Home / Carousel Background Color */\n\n  --primary: rgba(22, 52, 67, 0.726);\n  /* --primary: #155bd5; */\n\n  /* Home / Carousel Background Color */\n\n  --primary-dark: #1c3ab6;\n  --primary-light: #e2f1ff;\n  --accent: #00d4d7;\n  --accent-dark: #00bac1;\n  --accent-light: #dff9f8;\n  --success: #13d527;\n  --success-dark: #00ae11;\n  --success-light: #eafbe7;\n  --secondary: #8f15d5;\n  --secondary-dark: #6013c7;\n  --secondary-light: #f4e5fa;\n  --info: #15b2d5;\n  --info-dark: #0f8ca8;\n  --info-light: #e0f5fa;\n  --caution: #dbbb25;\n  --caution-dark: #d58f15;\n  --caution-light: #fbf9e4;\n  --error: #e6185e;\n  --error-dark: #bf1257;\n  --error-light: #fce4eb;\n  --black: #1d1d1d;\n  --dark-1: #2d2d2d;\n  --dark-2: #4d4d4d;\n  --dark-3: #6d6d6d;\n  --gray-1: #8d8d8d;\n  --gray-2: #adadad;\n  --gray-3: #cdcdcd;\n  --gray-4: #e0e0e0;\n  --light-1: #efefef;\n  --light-2: #f5f5f5;\n  --light-3: #fafafa;\n  --white: #ffffff;\n   --color-white: #ffffff;\n  --gradient-1: linear-gradient(180deg, #155bd5 0%, #1c3ab6 100%);\n  --gradient-2: linear-gradient(180deg, #155bd5 13.02%, #00d4d7 85.42%);\n  --gradient-3: linear-gradient(180deg, #155bd5 0%, #8f15d5 100%);\n  --gradient-4: linear-gradient(180deg, #155bd5 0%, #13d527 100%);\n  --gradient-5: linear-gradient(180deg, #155bd5 0%, #15bbd5 100%);\n  --gradient-6: linear-gradient(180deg, #155bd5 0%, #dbbb25 100%);\n  --gradient-7: linear-gradient(180deg, #155bd5 0%, #e6185e 100%);\n  --gradient-8: linear-gradient(180deg, #1c3ab6 0%, #00bac1 100%);\n  --gradient-9: linear-gradient(180deg, #00d4d7 13.02%, #155bd5 85.42%);\n  --shadow-1: 0px 0px 1px rgba(40, 41, 61, 0.08),\n    0px 0.5px 2px rgba(96, 97, 112, 0.16);\n  --shadow-2: 0px 0px 1px rgba(40, 41, 61, 0.04),\n    0px 2px 4px rgba(96, 97, 112, 0.16);\n  --shadow-3: 0px 0px 2px rgba(40, 41, 61, 0.04),\n    0px 4px 8px rgba(96, 97, 112, 0.16);\n  --shadow-4: 0px 2px 4px rgba(40, 41, 61, 0.04),\n    0px 8px 16px rgba(96, 97, 112, 0.16);\n  --shadow-5: 0px 2px 8px rgba(40, 41, 61, 0.04),\n    0px 16px 24px rgba(96, 97, 112, 0.16);\n  --shadow-6: 0px 2px 8px rgba(40, 41, 61, 0.08),\n    0px 20px 32px rgba(96, 97, 112, 0.24);\n\t\n}\n\n/*--------------------------------------------------------------\n# General\n--------------------------------------------------------------*/\nbody {\n  font-family: var(--font-default);\n  color: var(--color-default);\n}\n\na {\n  color: var(--color-primary);\n  text-decoration: none;\n  transition: 0.3s;\n}\n\na:hover {\n  color: #82cbed;\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: var(--font-primary);\n  color: var(--black)\n}\n\np{color: var(--dark-3)}\n\n.pointer {cursor:pointer}\n\n.error { \n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-invalid-color);\n}\n\n/*--------------------------------------------------------------\n# Sections & Section Header\n--------------------------------------------------------------*/\nsection {\n  overflow: hidden;\n  padding: 80px 0;\n}\n\n.section-header {\n  text-align: center;\n  padding-bottom: 30px;\n}\n\n.section-header h2 {\n  /*font-size: 32px;*/\n  font-weight: 600;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  position: relative;\n}\n\n.section-header h2:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 60px;\n  height: 2px;\n  background: var(--color-primary);\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n}\n\n.section-header p {\n  margin-bottom: 0;\n}\n\n  .light-bg{ background:#f5f5f5;}\n  \n/* ===== Buttons Css ===== */\n.primary-btn {\n  background: var(--primary);\n  color: var(--white);\n  box-shadow: var(--shadow-2);\n}\n.active.primary-btn, .primary-btn:hover, .primary-btn:focus {\n  background: var(--primary-dark);\n  color: var(--white);\n  box-shadow: var(--shadow-4);\n}\n.deactive.primary-btn {\n  background: var(--gray-4);\n  color: var(--dark-3);\n  pointer-events: none;\n}\n\n.primary-btn-outline {\n  border-color: var(--primary);\n  color: var(--primary);\n}\n.active.primary-btn-outline, .primary-btn-outline:hover, .primary-btn-outline:focus {\n  background: var(--primary-dark);\n  color: var(--white);\n}\n.deactive.primary-btn-outline {\n  color: var(--dark-3);\n  border-color: var(--gray-4);\n  pointer-events: none;\n}\n\n.btn-get-started {\n\tfont-family: var(--primary);    \n\tfont-weight: bold;\n\tfont-size: 16px;\n\tline-height: 20px;\n\ttext-align: center;\n\tletter-spacing: 0.08em;\n\ttext-transform: uppercase;\n\tpadding: 12px 24px;\n\tborder-radius: 4px;\n\tletter-spacing: 1px;\n\tdisplay: inline-block;  \n\ttransition: 0.5s;\n\tcolor: var(--color-white);\n\tbackground: var(--color-primary);\n\tborder: 1px solid transparent;\n}\n\n/* Justified Text Container */\n.justified-text-container p {\n  text-align: justify;\n}\n\n/* Justified Heading Container */\n.justified-heading {\n  text-align: justify;\n}\n\n/*--------------------------------------------------------------\n# Breadcrumbs\n--------------------------------------------------------------*/\n.breadcrumbs {\n  padding: 140px 0 60px 0;\n  min-height: 30vh;\n  position: relative;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.breadcrumbs:before {\n  content: \"\";\n  /* background-color: rgba(21, 91, 213, 0.9); */\n  background-color: rgba(22, 52, 67, 0.726);  \n  position: absolute;\n  inset: 0;\n}\n\n.breadcrumbs h2 {\n  font-size: 56px;\n  font-weight: 500;\n  color: #fff;\n  font-family: var(--font-secondary);\n}\n\n.breadcrumbs ol {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0 0 10px 0;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: rgba(255,255,255,0.5);\n}\n\n.breadcrumbs ol a {\n  color: rgba(255, 255, 255, 1);\n  transition: 0.3s;\n}\n\n.breadcrumbs ol a:hover {\n  text-decoration: underline;\n}\n\n.breadcrumbs ol li+li {\n  padding-left: 10px;\n}\n\n.breadcrumbs ol li+li::before {\n  display: inline-block;\n  padding-right: 10px;\n  color: #fff;\n  content: \"/\";\n}\n\n/*--------------------------------------------------------------\n# Scroll top button\n--------------------------------------------------------------*/\n.scroll-top {\n  position: fixed;\n  visibility: hidden;\n  opacity: 0;\n  right: 15px;\n  bottom: 15px;\n  z-index: 99999;\n  background: var(--color-primary);\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  transition: all 0.4s;\n}\n\n.scroll-top i {\n  font-size: 24px;\n  color: #fff;\n  line-height: 0;\n}\n\n.scroll-top:hover {\n  background: rgba(86, 184, 230, 0.8);\n  color: #fff;\n}\n\n.scroll-top.active {\n  visibility: visible;\n  opacity: 1;\n}\n\n/*--------------------------------------------------------------\n# Preloader\n--------------------------------------------------------------*/\n#preloader {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  overflow: hidden;\n  background: #fff;\n  transition: all 0.6s ease-out;\n}\n\n#preloader:before {\n  content: \"\";\n  position: fixed;\n  top: calc(50% - 30px);\n  left: calc(50% - 30px);\n  border: 6px solid var(--color-primary);\n  border-top-color: #fff;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  -webkit-animation: animate-preloader 1s linear infinite;\n  animation: animate-preloader 1s linear infinite;\n}\n\n@-webkit-keyframes animate-preloader {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes animate-preloader {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/*--------------------------------------------------------------\n# Disable aos animation delay on mobile devices\n--------------------------------------------------------------*/\n@media screen and (max-width: 768px) {\n  [data-aos-delay] {\n    transition-delay: 0 !important;\n  }\n}\n\n/*--------------------------------------------------------------\n# Header\n--------------------------------------------------------------*/\n.header {\n  transition: all 0.5s;\n  z-index: 997;\n  padding: 24px 0;\n}\n\n@media (max-width: 1200px) {\n  .header {\n    padding: 12px 0;\n  }\n}\n\n.header.sticked {\n  background: var(--primary);\n  padding: 12px 0;\n}\n\n.header .logo img {\n  /*max-height: 40px;*/\n  margin-right: 6px;\n}\n\n.header .logo h1 {\n  font-size: 30px;\n  font-weight: 700;\n  color: #fff;\n  font-family: var(--font-secondary);\n  margin: 0;\n}\n\n/*--------------------------------------------------------------\n# Desktop Navigation\n--------------------------------------------------------------*/\n@media (min-width: 1280px) {\n  .navbar {\n    padding: 0;\n  }\n\n  .navbar ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    list-style: none;\n    align-items: center;\n  }\n\n  .navbar li {\n    position: relative;\n  }\n\n  .navbar a,\n  .navbar a:focus {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px 0 15px 30px;\n    font-family: var(--font-default);\n    font-size: 1em;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.6);\n    white-space: nowrap;\n    transition: 0.3s;\n  }\n\n  .navbar a i,\n  .navbar a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n  }\n\n  .navbar a:hover,\n  .navbar .active,\n  .navbar .active:focus,\n  .navbar li:hover>a {\n    color: #fff;\n  }\n\n  .navbar .dropdown ul {\n    display: block;\n    position: absolute;\n    left: 14px;\n    top: calc(100% + 30px);\n    margin: 0;\n    padding: 10px 0;\n    z-index: 99;\n    opacity: 0;\n    visibility: hidden;\n    background: #fff;\n    box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);\n    transition: 0.2s;\n  }\n\n  .navbar .dropdown ul li {\n    min-width: 200px;\n  }\n\n  .navbar .dropdown ul a {\n    padding: 10px 20px;\n    font-size: 15px;\n    text-transform: none;\n    color: var(--color-secondary);\n  }\n\n  .navbar .dropdown ul a i {\n    font-size: 12px;\n  }\n\n  .navbar .dropdown ul a:hover,\n  .navbar .dropdown ul .active:hover,\n  .navbar .dropdown ul li:hover>a {\n    color: var(--color-primary);\n  }\n\n  .navbar .dropdown:hover>ul {\n    opacity: 1;\n    top: 100%;\n    visibility: visible;\n  }\n\n  .navbar .dropdown .dropdown ul {\n    top: 0;\n    left: calc(100% - 30px);\n    visibility: hidden;\n  }\n\n  .navbar .dropdown .dropdown:hover>ul {\n    opacity: 1;\n    top: 0;\n    left: 100%;\n    visibility: visible;\n  }\n}\n\n@media (min-width: 1280px) and (max-width: 1366px) {\n  .navbar .dropdown .dropdown ul {\n    left: -90%;\n  }\n\n  .navbar .dropdown .dropdown:hover>ul {\n    left: -100%;\n  }\n}\n\n@media (min-width: 1280px) {\n\n  .mobile-nav-show,\n  .mobile-nav-hide {\n    display: none;\n  }\n}\n\n/*--------------------------------------------------------------\n# Mobile Navigation\n--------------------------------------------------------------*/\n@media (max-width: 1279px) {\n  .navbar {\n    position: fixed;\n    top: 0;\n    right: -100%;\n    width: 100%;\n    max-width: 400px;\n    bottom: 0;\n    transition: 0.3s;\n    z-index: 9997;\n  }\n\n  .navbar ul {\n    position: absolute;\n    inset: 0;\n    padding: 50px 0 10px 0;\n    margin: 0;\n    /* background: rgba(21, 91, 213, 0.9); */\n    background-color: rgba(22, 52, 67, 0.726);  \n    overflow-y: auto;\n    transition: 0.3s;\n    z-index: 9998;\n  }\n\n  .navbar a,\n  .navbar a:focus {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 20px;\n    font-family: var(--font-default);\n    /*font-size: 15px;*/\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.7);\n    white-space: nowrap;\n    transition: 0.3s;\n  }\n\n  .navbar a i,\n  .navbar a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n  }\n\n  .navbar a:hover,\n  .navbar .active,\n  .navbar .active:focus,\n  .navbar li:hover>a {\n    color: #fff;\n  }\n\n  .navbar .dropdown ul,\n  .navbar .dropdown .dropdown ul {\n    position: static;\n    display: none;\n    padding: 10px 0;\n    margin: 10px 20px;\n    background-color: rgba(20, 35, 51, 0.6);\n  }\n\n  .navbar .dropdown>.dropdown-active,\n  .navbar .dropdown .dropdown>.dropdown-active {\n    display: block;\n  }\n\n  .mobile-nav-show {\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 28px;\n    cursor: pointer;\n    line-height: 0;\n    transition: 0.5s;\n  }\n\n  .mobile-nav-hide {\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 32px;\n    cursor: pointer;\n    line-height: 0;\n    transition: 0.5s;\n    position: fixed;\n    right: 15px;\n    top: 35px;\n    z-index: 9999;\n  }\n\n  .mobile-nav-active {\n    overflow: hidden;\n  }\n\n  .mobile-nav-active .navbar {\n    right: 0;\n  }\n\n  .mobile-nav-active .navbar:before {\n    content: \"\";\n    position: fixed;\n    inset: 0;\n    background: rgba(27, 47, 69, 0.7);\n    z-index: 9996;\n  }\n}\n\n/*--------------------------------------------------------------\n# Hero Section\n--------------------------------------------------------------*/\n\n.hero {\nposition: relative;\n    padding: 200px 0 100px 0;\n    background: var(--primary);\n}\n\n.hero .shape {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    height: 350px;\n\t\n}\n\n\n/*.hero {\n  width: 100%;\n  min-height: 100vh;\n  background: url(\"../images/hero-bg.jpg\") top center;\n  background-size: cover;\n  position: relative;\n  padding: 150px 0 120px;\n  z-index: 3;\n}\n\n@media (min-width: 1034px) {\n  .hero:after {\n    position: absolute;\n    content: \"\";\n    width: 40%;\n    background: var(--color-primary);\n    top: 0;\n    bottom: 0;\n  }\n}\n\n.hero:before {\n  position: absolute;\n  content: \"\";\n  /*background: rgba(27, 47, 69, 0.6);*/\n   /*background: #155bd5;\n  inset: 0;\n}*/\n\n/*@media (max-width: 1034px) {\n  .hero:before {\n    background: rgba(27, 47, 69, 0.7);\n  }\n}*/\n\n.hero .container {\n  z-index: 1;\n}\n\n@media (min-width: 1365px) {\n  .hero {\n    background-attachment: fixed;\n  }\n}\n\n.hero h2 {\n  /*margin: 0;\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #fff;\n  font-family: var(--font-secondary);\n  */\n  font-size: 2.75em;\n    line-height: 1.25;\n  font-weight: 700;\n    color: var(--white);\n    text-shadow: 0px 3px 8px #00000017;\n    text-transform: capitalize;\n}\n\n.hero blockquote {\n  \n  padding-left: 20px;   \n  border-left: 2px solid rgba(255,255,255,.7);\n  margin: 40px 0;\n   \n}\n\n.hero p {  \n    color: var(--white);\n    opacity: 0.7;\n}\n\n.hero .btn-get-started {\n  font-family: var(--primary);    \n  font-weight: bold;\n    font-size: 16px;\n    line-height: 20px;\n    text-align: center;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    padding: 12px 24px;\n    border-radius: 4px;\n  letter-spacing: 1px;\n  display: inline-block;  \n  transition: 0.5s;\n  color: var(--color-primary);\n  background: var(--color-white);\n  border: 1px solid transparent;\n  z-index:1000;\n\n}\n\n\n.hero .btn-get-started:hover {\n\t\n\tbackground: transparent;\n\tcolor: var(--white);\n\tborder-color: var(--white);\n\n}\n\n\n.hero .btn-watch-video {\n\tz-index:1000;\n  font-size: 16px;\n  transition: 0.5s;\n  margin-left: 25px;\n  color: var(--white);\n  font-weight: 600;\n}\n\n.hero .btn-watch-video i {\n  color: var(--color-white);\n  font-size: 32px;\n  transition: 0.3s;\n  line-height: 0;\n  margin-right: 8px;\n}\n\n.hero .btn-watch-video:hover {\n  color: #fff;\n}\n\n.hero .btn-watch-video:hover i {\n  color: #fff;\n}\n\n\n.hero .header-image img {\n    width: 100%;\n    border-radius: 20px 20px 0px 0px;\t\n    }\n\n@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {\n  .hero .header-image {\n    display: none;\n  }\n  \n  .hero .shape {\n    height: 100px;\n  }\n}\n\n\n\n\n@media (max-width: 640px) {\n  .hero h2 {\n    font-size: 30px;\n    line-height: 42px;\n  }\n  \n  .hero {    \n    padding: 100px 0 60px 0;\n   \n}\n\n\n .hero .header-image {\n    margin-top: 40px;\n}\n\n  .hero .btn-get-started,\n  .hero .btn-watch-video {\n    font-size: 13px;\n  }\n}\n\n\n.carousel-indicators [data-bs-target] {  \n   /* background-color: #155bd5; */\n  background-color: rgba(22, 52, 67, 0.726);     \n   }\n\n\n.carousel-indicators {   \n    bottom: -25px;\n}\n\t\n/*.header-image img{\n\t-webkit-clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);\n-clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);\n\n}*/\n\n/*--------------------------------------------------------------\n# Why Choose Us Section\n--------------------------------------------------------------*/\n.why-us {\n  padding-bottom: 0;\n}\n\n.why-us .img-bg {\n  min-height: 500px;\n  background-size: cover;\n}\n\n.why-us .slides {\n  background-color: #f7f9fc;\n}\n\n.why-us h3 {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--color-secondary);\n}\n\n.why-us h4 {\n  font-size: 18px;\n  font-weight: 400;\n  color: #29486a;\n  font-family: var(--font-secondary);\n}\n\n.why-us .swiper {\n  margin: 140px 140px 120px 140px;\n  overflow: hidden;\n}\n\n.why-us .swiper-button-prev:after,\n.why-us .swiper-button-next:after {\n  font-size: 24px;\n  color: var(--color-secondary);\n}\n\n.why-us .swiper-button-prev {\n  left: 80px;\n}\n\n.why-us .swiper-button-next {\n  right: 80px;\n}\n\n.why-us .swiper-pagination {\n  margin-top: 30px;\n  position: relative;\n}\n\n.why-us .swiper-pagination .swiper-pagination-bullet {\n  background-color: var(--color-secondary);\n}\n\n.why-us .swiper-pagination .swiper-pagination-bullet-active {\n  background-color: var(--color-primary);\n}\n\n@media (max-width: 1200px) {\n  .why-us .swiper {\n    margin: 60px 60px 40px 60px;\n  }\n\n  .why-us .swiper-button-prev,\n  .why-us .swiper-button-next {\n    display: none;\n  }\n}\n\n@media (max-width: 575px) {\n  .why-us .swiper {\n    margin: 40px 40px 20px 40px;\n  }\n}\n\n.page-about .why-us {\n  padding: 0 0 80px 0;\n}\n\n/*--------------------------------------------------------------\n# About Section\n--------------------------------------------------------------*/\n.about .content h3 {\n  font-weight: 700;\n  font-size: 36px;\n  font-family: var(--font-secondary);\n  color: var(--color-secondary);\n}\n\n.about .content p {\n  margin: 30px 0;\n  color: #29486a;\n}\n\n.about .content ul {\n  list-style: none;\n  padding: 0;\n}\n\n.about .content ul li {\n  padding: 0 0 15px 26px;\n  position: relative;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.about .content ul i {\n  position: absolute;\n  font-size: 20px;\n  left: 0;\n  top: -3px;\n  color: var(--color-primary);\n}\n\n/*--------------------------------------------------------------\n# Services List Section\n--------------------------------------------------------------*/\n\n/*.services-list {\n\tbackground:var(--white)\n}*/\n\n.services-list .service-item {\n  position: relative;    \n}\n\n.services-list .service-item .icon i {\n  font-size: 40px;\n  line-height: 0;\n  margin-right: 20px; \n}\n\n.services-list .service-item .title {\n  font-weight: 700;\n  margin: 8px 0;\n  font-size: 24px;\n}\n\n.services-list .service-item .title a {\n  color: var(--color-black);\n}\n\n.services-list .service-item .title a:hover {\n  color: var(--color-primary);\n}\n\n.services-list .service-item .description {\n  line-height: 1.5;\n  /* font-size: 1.15rem; */\n  font-size: 1.10rem;\n}\n\n.section-header p{font-size:18px; margin-bottom:25px;}\n\n.services-list  .single-service {\n  position: relative;\n  text-align: left;\n  padding: 30px;\n  box-shadow: var(--shadow-2);\n  border-radius: 5px;\n  border: 1px solid var(--gray-4);\n  background-color: var(--white);\n  overflow: hidden;\n  /*margin-top: 30px;*/\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .services-list  .single-service {\n    padding: 40px;\n  }\n}\n@media (max-width: 767px) {\n  .services-list  .single-service {\n    padding: 35px;\n  }\n}\n.services-list .single-service::before {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 4px;\n  width: 0%;\n  content: \"\";\n  background-color: var(--primary);\n  transition: all 0.4s ease-in-out;\n}\n.services-list .single-service:hover {\n  box-shadow: var(--shadow-4);\n}\n.services-list .single-service:hover::before {\n  width: 100%;\n}\n.services-list .single-service .serial {\n  font-size: 45px;\n  display: block;\n  margin-bottom: 7px;\n  -webkit-text-stroke-width: 1px;\n  /*-webkit-text-fill-color: transparent;*/\n  /*-webkit-text-stroke-color: var(--primary);*/\n  font-weight: 800;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.services-list .single-service:hover .serial {\n  -webkit-text-stroke-color: transparent;\n  -webkit-text-fill-color: var(--primary);\n}\n.services-list .single-service h3 {\n  color: var(--black);\n  font-weight: 600;\n}\n.services-list .single-service p {\n  color: var(--dark-3) !important;\n  margin-top: 8px;\n}\n.services-list .single-service .light-rounded-buttons {\n  margin-top: 25px;\n}\n\n/*--------------------------------------------------------------\n# Call To Action Section\n--------------------------------------------------------------*/\n\n.facts {\n /* background: linear-gradient(rgba(21 91 213 / 80%), rgba(21 91 213 / 100%)), url(\"./images/cta-bg1.jpg\") center center; */\n background: linear-gradient(hsla(210, 1%, 35%, 0.958), rgba(21 91 213 / 80%)), url(\"./images/cta-bg1.jpg\") center center;\n  background-size: cover;\n  padding: 100px 0; \n}\n\n@media (min-width: 1365px) {\n  .facts {\n    background-attachment: fixed;\n  }\n}\n\n/*.call-to-action h3 {\n  color: #fff;\n  font-size: 28px;\n  margin-bottom: 25px;\n  font-weight: 700;  \n}*/\n.facts h3 {\n\tcolor: #fff;\n\t/*font-size: 28px;*/\n\tmargin-bottom: 6px;\n\tfont-weight: 400;\n}\n\n.facts p {\n  color: #9ccff7;\n  margin-bottom: 25px;\n  font-size:18px;\n  \n}\n\n\n#facts .section-header h2:after {    \nbackground: var(--color-white);}   \n\n\n.facts .cta-btn {\n  font-family: var(--font-default);\n  font-weight: 500;\n  font-size: 16px;\n  letter-spacing: 1px;\n  display: inline-block;\n  padding: 12px 40px;\n  border-radius: 50px;\n  transition: 0.5s;\n  margin: 10px;\n  color: #fff;\n  background: #2aa5df;\n}\n\n.facts .cta-btn:hover {\n  background: var(--color-primary);\n}\n\n.facts .container {\n  position: relative;\n  z-index: 10;\n}\n\n.facts .counters span { \n  font-weight: 800;\n  font-size: 68px;\n  display: block;\n  color: #fff;\n}\n\n.facts .counters p {\n  padding: 0;\n  margin: 0 0 10px 0;\n  font-size: 18px;\n  font-weight:400;\n  color: #9ccff7;\n}\n\n.facts .facts-img {\n  text-align: center;\n  padding-top: 20px;\n}\n\n.facts .fct-title {\n    color: #fff;\n    font-size: 28px;\n    font-weight: 700;\n}\n/*--------------------------------------------------------------\n# Features Section\n--------------------------------------------------------------*/\n.features {\n  padding-bottom: 0;\n  background: var(--light-2);\n}\n\n.features h3 {\n  color: var(--color-secondary);\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 30px;\n}\n\n.features .icon-list i {\n  margin-right: 10px;\n  font-size: 24px;\n  line-height: 1.2;\n}\n\n.features .icon-list span {\n  font-size: 18px;\n  color: #29486a;\n}\n\n.features .phone-wrap {\n  position: absolute;\n  right: 0;\n}\n\n@media (max-width: 768px) {\n  .features .phone-wrap {\n    position: relative;\n  }\n}\n\n.features .phone-wrap img {\n  min-width: 340px;\n}\n\n@media (max-width: 992px) {\n  .features .phone-wrap img {\n    margin-top: 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .features .phone-wrap img {\n    width: 100%;\n  }\n  .features .details {  \n   padding: 0px 0px 50px 0px !important; \n}\n}\n\n.features .details {\n  margin-top: 0px;\n  /*padding: 120px 0; */\n   padding: 0px 0px 100px 0px; \n}\n\n.features .details h2 { \n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.features .details p {\n  margin-bottom: 20px;\n  font-size: 15px;\n}\n\n\n.features .details .btn-get-started {\n  font-family: var(--primary);    \n  font-weight: bold;\n    font-size: 16px;\n    line-height: 20px;\n    text-align: center;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    padding: 12px 24px;\n    border-radius: 4px;\n  letter-spacing: 1px;\n  display: inline-block;  \n  transition: 0.5s;\n  color: var(--color-white);\n  background: var(--color-primary);\n  border: 1px solid transparent;\n\n}\n\n\n\n\n.features .details .btn-get-started:hover {\n\tbackground: transparent;\n\tcolor: var(--primary);\n\tborder-color: var(--color-primary);\n\n}\n\n\n/*--------------------------------------------------------------\n# Recent Blog Posts Section\n--------------------------------------------------------------*/\n.recent-posts .post-box {\n  transition: 0.3s;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.recent-posts .post-box .post-img {\n  overflow: hidden;\n  position: relative;\n}\n\n.recent-posts .post-box .post-img img {\n  transition: 0.5s;\n}\n\n.recent-posts .post-box .meta {\n  margin-top: 15px;\n}\n\n.recent-posts .post-box .meta .post-date {\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--color-primary);\n}\n\n.recent-posts .post-box .meta .post-author {\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--color-secondary);\n}\n\n.recent-posts .post-box .post-title {\n  font-size: 18px;\n  color: var(--color-secondary);\n  font-weight: 700;\n  margin: 15px 0 0 0;\n  position: relative;\n  transition: 0.3s;\n}\n\n.recent-posts .post-box p {\n  margin: 15px 0 0 0;\n  color: rgba(27, 47, 69, 0.7);\n}\n\n.recent-posts .post-box .readmore {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  line-height: 1;\n  transition: 0.3s;\n  margin-top: 15px;\n}\n\n.recent-posts .post-box .readmore i {\n  line-height: 0;\n  margin-left: 4px;\n  font-size: 18px;\n}\n\n.recent-posts .post-box:hover .post-title {\n  color: var(--color-primary);\n}\n\n.recent-posts .post-box:hover .post-img img {\n  transform: scale(1.1);\n}\n\n/*--------------------------------------------------------------\n# Team Section\n--------------------------------------------------------------*/\n.team .team-member {\n  overflow: hidden;\n  background: #fff;\n}\n\n.team .team-member .member-img {\n  position: relative;\n  overflow: hidden;\n}\n\n.team .team-member .social {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  height: 40px;\n  opacity: 0;\n  transition: ease-in-out 0.3s;\n  background: rgba(255, 255, 255, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.team .team-member .social a {\n  transition: color 0.3s;\n  color: #31547c;\n  margin: 0 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.team .team-member .social a i {\n  line-height: 0;\n}\n\n.team .team-member .social a:hover {\n  color: var(--color-primary);\n}\n\n.team .team-member .social i {\n  font-size: 18px;\n  margin: 0 2px;\n}\n\n.team .team-member .member-info {\n  padding: 25px 15px 0 15px;\n  text-align: center;\n}\n\n.team .team-member .member-info h4 {\n  font-weight: 700;\n  margin-bottom: 5px;\n  font-size: 18px;\n  color: var(--color-secondary);\n}\n\n.team .team-member .member-info span {\n  display: block;\n  font-size: 13px;\n  font-weight: 400;\n  color: #6c757d;\n}\n\n.team .team-member .member-info p {\n  font-style: italic;\n  font-size: 14px;\n  line-height: 26px;\n  color: #6c757d;\n}\n\n.team .team-member:hover .social {\n  opacity: 1;\n}\n\n/*--------------------------------------------------------------\n# Services Cards Section\n--------------------------------------------------------------*/\n.services-cards {\n  background: #f7f9fc;\n}\n\n.services-cards .card-item {\n  border: 1px solid rgba(27, 47, 69, 0.1);\n  background: #fff;\n  position: relative;\n  border-radius: 0;\n}\n\n.services-cards .card-item .card-bg {\n  min-height: 270px;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.services-cards .card-item .card-body {\n  padding: 30px;\n}\n\n.services-cards .card-item h4 {\n  font-weight: 700;\n  font-size: 20px;\n  margin-bottom: 15px;\n  color: var(--color-secondary);\n}\n\n.services-cards .card-item p {\n  color: var(--color-secondary);\n  margin: 0;\n}\n\n\n\n/*--------------------------------------------------------------\n# Cource Details\n--------------------------------------------------------------*/\n.course-details h3 {\n  font-size: 24px;\n  margin: 30px 0 15px 0;\n  font-weight: 700;\n  position: relative;\n  padding-bottom: 10px;\n}\n\n.course-details h3:before {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 1px;\n  background: #eef0ef;\n  bottom: 0;\n  left: 0;\n}\n\n.course-details h3:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 60px;\n  height: 1px;\n  background: #5fcf80;\n  bottom: 0;\n  left: 0;\n}\n\n.course-details .course-info {\n  background: #f6f7f6;\n  padding: 10px 15px;\n  margin-bottom: 15px;\n}\n\n.course-details .course-info h5 {\n  font-weight: 400;\n  font-size: 16px;\n  margin: 0;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.course-details .course-info p {\n  margin: 0;\n  font-weight: 600;\n}\n\n.course-details .course-info a {\n  color: #657a6d;\n}\n\n/*--------------------------------------------------------------\n# Cource Details Tabs\n--------------------------------------------------------------*/\n.cource-details-tabs {\n  overflow: hidden;\n  padding-top: 0;\n}\n\n.cource-details-tabs .nav-tabs {\n  border: 0;\n}\n\n.cource-details-tabs .nav-link {\n  border: 0;\n  padding: 12px 15px 12px 0;\n  transition: 0.3s;\n  color: #37423b;\n  border-radius: 0;\n  border-right: 2px solid #e2e7e4;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.cource-details-tabs .nav-link:hover {\n  color: #5fcf80;\n}\n\n.cource-details-tabs .nav-link.active {\n  color: #5fcf80;\n  border-color: #5fcf80;\n}\n\n.cource-details-tabs .tab-pane.active {\n  -webkit-animation: fadeIn 0.5s ease-out;\n  animation: fadeIn 0.5s ease-out;\n}\n\n.cource-details-tabs .details h3 {\n  font-size: 26px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #37423b;\n}\n\n.cource-details-tabs .details p {\n  color: #777777;\n}\n\n.cource-details-tabs .details p:last-child {\n  margin-bottom: 0;\n}\n\n@media (max-width: 992px) {\n  .cource-details-tabs .nav-link {\n    border: 0;\n    padding: 15px;\n  }\n\n  .cource-details-tabs .nav-link.active {\n    color: #fff;\n    background: #5fcf80;\n  }\n}\n\n/*--------------------------------------------------------------\n# Testimonials Section\n--------------------------------------------------------------*/\n.testimonials .testimonial-item {\n  box-sizing: content-box;\n  padding: 30px;\n  margin: 40px 30px;\n  box-shadow: 0px 0 20px rgba(27, 47, 69, 0.1);\n  background: #fff;\n  min-height: 320px;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  transition: 0.3s;\n}\n\n.testimonials .testimonial-item .stars {\n  margin-bottom: 15px;\n}\n\n.testimonials .testimonial-item .stars i {\n  color: #ffc107;\n  margin: 0 1px;\n}\n\n.testimonials .testimonial-item .testimonial-img {\n  width: 90px;\n  border-radius: 50%;\n  border: 4px solid #fff;\n  margin: 0 auto;\n}\n\n.testimonials .testimonial-item h3 {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 10px 0 5px 0;\n  color: #111;\n}\n\n.testimonials .testimonial-item h4 {\n  font-size: 14px;\n  color: #999;\n  margin: 0;\n}\n\n.testimonials .testimonial-item p {\n  font-style: italic;\n  margin: 0 auto 15px auto;\n}\n\n.testimonials .swiper-pagination {\n  margin-top: 20px;\n  position: relative;\n}\n\n.testimonials .swiper-pagination .swiper-pagination-bullet {\n  width: 10px;\n  height: 10px;\n  background-color: #e8eff6;\n  opacity: 1;\n}\n\n.testimonials .swiper-pagination .swiper-pagination-bullet-active {\n  background-color: var(--color-primary);\n}\n\n.testimonials .swiper-slide {\n  opacity: 0.3;\n}\n\n@media (max-width: 1199px) {\n  .testimonials .swiper-slide-active {\n    opacity: 1;\n  }\n\n  .testimonials .swiper-pagination {\n    margin-top: 0;\n  }\n\n  .testimonials .testimonial-item {\n    margin: 40px 20px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .testimonials .swiper-slide-next {\n    opacity: 1;\n    transform: scale(1.12);\n  }\n}\n\n/*--------------------------------------------------------------\n# Portfolio Section\n--------------------------------------------------------------*/\n.portfolio .portfolio-flters {\n  padding: 0;\n  margin: 0 auto 30px auto;\n  list-style: none;\n  text-align: center;\n}\n\n.portfolio .portfolio-flters li {\n  color: var(--color-secondary);\n  cursor: pointer;\n  display: inline-block;\n  padding: 0;\n  font-size: 18px;\n  font-weight: 400;\n  margin: 0 10px;\n  line-height: 1;\n  margin-bottom: 5px;\n  transition: all 0.3s ease-in-out;\n}\n\n.portfolio .portfolio-flters li:hover,\n.portfolio .portfolio-flters li.filter-active {\n  color: var(--color-primary);\n}\n\n.portfolio .portfolio-flters li:first-child {\n  margin-left: 0;\n}\n\n.portfolio .portfolio-flters li:last-child {\n  margin-right: 0;\n}\n\n@media (max-width: 575px) {\n  .portfolio .portfolio-flters li {\n    font-size: 14px;\n    margin: 0 5px;\n  }\n}\n\n.portfolio .portfolio-item {\n  position: relative;\n}\n\n.portfolio .portfolio-item .portfolio-info {\n  opacity: 0;\n  position: absolute;\n  left: 30px;\n  right: 30px;\n  bottom: 0;\n  z-index: 3;\n  transition: all ease-in-out 0.3s;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 15px;\n}\n\n.portfolio .portfolio-item .portfolio-info h4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-default);\n  padding-right: 50px;\n}\n\n.portfolio .portfolio-item .portfolio-info p {\n  color: #6c757d;\n  font-size: 14px;\n  margin-bottom: 0;\n  padding-right: 50px;\n}\n\n.portfolio .portfolio-item .portfolio-info .preview-link,\n.portfolio .portfolio-item .portfolio-info .details-link {\n  position: absolute;\n  right: 50px;\n  font-size: 24px;\n  top: calc(50% - 14px);\n  color: rgba(27, 47, 69, 0.7);\n  transition: 0.3s;\n  line-height: 0;\n}\n\n.portfolio .portfolio-item .portfolio-info .preview-link:hover,\n.portfolio .portfolio-item .portfolio-info .details-link:hover {\n  color: var(--color-primary);\n}\n\n.portfolio .portfolio-item .portfolio-info .details-link {\n  right: 14px;\n  font-size: 28px;\n}\n\n.portfolio .portfolio-item:hover .portfolio-info {\n  opacity: 1;\n  bottom: 20px;\n}\n\n/*--------------------------------------------------------------\n# Portfolio Details\n--------------------------------------------------------------*/\n.portfolio-details .portfolio-details-slider img {\n  width: 100%;\n}\n\n.portfolio-details .portfolio-details-slider .swiper-pagination {\n  margin-top: 20px;\n  position: relative;\n}\n\n.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet {\n  width: 12px;\n  height: 12px;\n  background-color: #fff;\n  opacity: 1;\n  border: 1px solid var(--color-primary);\n}\n\n.portfolio-details .portfolio-details-slider .swiper-pagination .swiper-pagination-bullet-active {\n  background-color: var(--color-primary);\n}\n\n.portfolio-details .portfolio-info {\n  padding: 30px;\n  box-shadow: 0px 0 30px rgba(27, 47, 69, 0.1);\n}\n\n.portfolio-details .portfolio-info h3 {\n  font-size: 22px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #d6e2ef;\n}\n\n.portfolio-details .portfolio-info ul {\n  list-style: none;\n  padding: 0;\n  font-size: 15px;\n}\n\n.portfolio-details .portfolio-info ul li+li {\n  margin-top: 10px;\n}\n\n/*.portfolio-details .portfolio-description {\n *padding-top: 30px;*\n}*/\n\n.portfolio-details .portfolio-description h2 {\n  font-size: 26px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  color: var(--color-secondary);\n}\n\n.portfolio-details .portfolio-description p {\n  padding: 0;\n}\n\n/*--------------------------------------------------------------\n# Contact Section\n--------------------------------------------------------------*/\n.contact {\n background: #f5f5f5 url(\"./images/contact-bg.png\") left top no-repeat;\n  background-size: contain;\n  position: relative;\n  \n  \n}\n\n@media (max-width: 640px) {\n  .contact {\n    background-position: center 50px;\n  }\n}\n\n.contact:before {\n  content: \"\";\n  background: rgba(255, 255, 255, 0.7);\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.contact .info-item+.info-item {\n  margin-top: 40px;\n}\n\n.contact .info-item i {\n  font-size: 20px;\n  background: var(--color-primary);\n  color: #fff;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50px;\n  transition: all 0.3s ease-in-out;\n  margin-right: 15px;\n}\n\n.contact .info-item h4 {\n  padding: 0;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 5px;\n  color: #1c88ba;\n}\n\n.contact .info-item p {\n  padding: 0;\n  margin-bottom: 0;\n  font-size: 14px;\n}\n\n.contact .php-email-form {\n  width: 100%;\n}\n\n.contact .php-email-form .form-group {\n  padding-bottom: 8px;\n}\n\n.contact .php-email-form .error-message {\n  display: none;\n  color: #fff;\n  background: #df1529;\n  text-align: left;\n  padding: 15px;\n  font-weight: 600;\n}\n\n.contact .php-email-form .error-message br+br {\n  margin-top: 25px;\n}\n\n.contact .php-email-form .sent-message {\n  display: none;\n  color: #fff;\n  background: #059652;\n  text-align: center;\n  padding: 15px;\n  font-weight: 600;\n}\n\n.contact .php-email-form .loading {\n  display: none;\n  background: #fff;\n  text-align: center;\n  padding: 15px;\n}\n\n.contact .php-email-form .loading:before {\n  content: \"\";\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin: 0 10px -6px 0;\n  border: 3px solid #059652;\n  border-top-color: #fff;\n  -webkit-animation: animate-loading 1s linear infinite;\n  animation: animate-loading 1s linear infinite;\n}\n\n.contact .php-email-form input,\n.contact .php-email-form textarea {\n  border-radius: 0;\n  box-shadow: none;\n  font-size: 14px;\n  padding: 12px 15px;\n}\n\n.contact .php-email-form input:focus,\n.contact .php-email-form textarea:focus {\n  border-color: var(--color-primary);\n}\n\n.contact .php-email-form textarea {\n  padding: 10px 12px;\n}\n\n\n.contact .php-email-form button[type=submit] {\n  font-family: var(--primary);    \n  font-weight: bold;\n    font-size: 16px;\n    line-height: 20px;\n    text-align: center;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    padding: 12px 24px;\n    border-radius: 4px;\n  letter-spacing: 1px;\n  display: inline-block;  \n  transition: 0.5s;\n  color: var(--color-white);\n  background: var(--color-primary);\n  border: 1px solid transparent;\n\n}\n\n.contact .php-email-form button[type=submit]:hover {\n\tbackground: transparent;\n\tcolor: var(--primary);\n\tborder-color: var(--color-primary);\n\n}\n\n\n@-webkit-keyframes animate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes animate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/*--------------------------------------------------------------\n# Blog Stylings\n--------------------------------------------------------------*/\n/*--------------------------------------------------------------\n# Blog Home Posts List\n--------------------------------------------------------------*/\n.blog .posts-list article {\n  height: 100%;\n  border-bottom: 1px solid #d6e2ef;\n  padding-bottom: 30px;\n}\n\n.blog .posts-list article+article {\n  margin-top: 60px;\n}\n\n.blog .posts-list .post-img {\n  max-height: 240px;\n  overflow: hidden;\n}\n\n.blog .posts-list .title {\n  font-size: 20px;\n  font-weight: 600;\n  padding: 0;\n  margin: 20px 0 0 0;\n}\n\n.blog .posts-list .title a {\n  color: var(--color-secondary);\n  transition: 0.3s;\n}\n\n.blog .posts-list .title a:hover {\n  color: var(--color-primary);\n}\n\n.blog .posts-list .meta-top {\n  margin-top: 20px;\n  color: #467ab3;\n}\n\n.blog .posts-list .meta-top ul {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n}\n\n.blog .posts-list .meta-top ul li+li {\n  padding-left: 20px;\n}\n\n.blog .posts-list .meta-top i {\n  font-size: 16px;\n  margin-right: 8px;\n  line-height: 0;\n  color: rgba(86, 184, 230, 0.8);\n}\n\n.blog .posts-list .meta-top a {\n  color: #467ab3;\n  font-size: 14px;\n  display: inline-block;\n  line-height: 1;\n}\n\n.blog .posts-list .content {\n  margin-top: 20px;\n}\n\n.blog .posts-list .read-more a {\n  display: inline-block;\n  color: #1f98d1;\n  transition: 0.3s;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.blog .posts-list .read-more a:hover {\n  color: var(--color-primary);\n}\n\n/*--------------------------------------------------------------\n# Blog Details Page\n--------------------------------------------------------------*/\n.blog .blog-details {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n}\n\n.blog .blog-details .post-img {\n  margin: -30px -30px 20px -30px;\n  overflow: hidden;\n}\n\n.blog .blog-details .title {\n  font-size: 28px;\n  font-weight: 700;\n  padding: 0;\n  margin: 20px 0 0 0;\n  color: var(--color-secondary);\n}\n\n.blog .blog-details .content {\n  margin-top: 20px;\n}\n\n.blog .blog-details .content h3 {\n  font-size: 22px;\n  margin-top: 30px;\n  font-weight: bold;\n}\n\n.blog .blog-details .content blockquote {\n  overflow: hidden;\n  background-color: rgba(27, 47, 69, 0.06);\n  padding: 60px;\n  position: relative;\n  text-align: center;\n  margin: 20px 0;\n}\n\n.blog .blog-details .content blockquote p {\n  color: var(--color-default);\n  line-height: 1.6;\n  margin-bottom: 0;\n  font-style: italic;\n  font-weight: 500;\n  font-size: 22px;\n}\n\n.blog .blog-details .content blockquote:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background-color: var(--color-secondary);\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.blog .blog-details .meta-top {\n  margin-top: 20px;\n  color: var(--color-gray);\n}\n\n.blog .blog-details .meta-top ul {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n}\n\n.blog .blog-details .meta-top ul li+li {\n  padding-left: 20px;\n}\n\n.blog .blog-details .meta-top i {\n  font-size: 16px;\n  margin-right: 8px;\n  line-height: 0;\n  color: rgba(86, 184, 230, 0.8);\n}\n\n.blog .blog-details .meta-top a {\n  color: var(--color-gray);\n  font-size: 14px;\n  display: inline-block;\n  line-height: 1;\n}\n\n.blog .blog-details .meta-bottom {\n  padding-top: 10px;\n  border-top: 1px solid rgba(27, 47, 69, 0.15);\n}\n\n.blog .blog-details .meta-bottom i {\n  color: #38618e;\n  display: inline;\n}\n\n.blog .blog-details .meta-bottom a {\n  color: rgba(27, 47, 69, 0.8);\n  transition: 0.3s;\n}\n\n.blog .blog-details .meta-bottom a:hover {\n  color: var(--color-primary);\n}\n\n.blog .blog-details .meta-bottom .cats {\n  list-style: none;\n  display: inline;\n  padding: 0 20px 0 0;\n  font-size: 14px;\n}\n\n.blog .blog-details .meta-bottom .cats li {\n  display: inline-block;\n}\n\n.blog .blog-details .meta-bottom .tags {\n  list-style: none;\n  display: inline;\n  padding: 0;\n  font-size: 14px;\n}\n\n.blog .blog-details .meta-bottom .tags li {\n  display: inline-block;\n}\n\n.blog .blog-details .meta-bottom .tags li+li::before {\n  padding-right: 6px;\n  color: var(--color-default);\n  content: \",\";\n}\n\n.blog .blog-details .meta-bottom .share {\n  font-size: 16px;\n}\n\n.blog .blog-details .meta-bottom .share i {\n  padding-left: 5px;\n}\n\n.blog .post-author {\n  padding: 20px;\n  margin-top: 30px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.blog .post-author img {\n  max-width: 120px;\n  margin-right: 20px;\n}\n\n.blog .post-author h4 {\n  font-weight: 600;\n  font-size: 22px;\n  margin-bottom: 0px;\n  padding: 0;\n  color: var(--color-secondary);\n}\n\n.blog .post-author .social-links {\n  margin: 0 10px 10px 0;\n}\n\n.blog .post-author .social-links a {\n  color: rgba(27, 47, 69, 0.5);\n  margin-right: 5px;\n}\n\n.blog .post-author p {\n  font-style: italic;\n  color: rgba(var(--color-gray-rgb), 0.8);\n  margin-bottom: 0;\n}\n\n\n/*--------------------------------------------------------------\n#.management\n--------------------------------------------------------------*/\n.management {\n  background: var(--light-2);\n}\n\n.management .member {\n  position: relative;\n  box-shadow: 0px 2px 15px rgba(44, 73, 100, 0.08);\n  padding: 20px;\n  border-radius: 10px;\n  background:#fff;  \n}\n \n@media screen and (min-width: 768px) {\n  \n  \n}\n\n\n@media screen and (max-width: 768px) {\n  .management .member {\n  margin:5px;\n}\n.management .member .member-info {\n  padding-left: 0px !important;\n}\n.management .member {\n    padding: 25px  10px!important;\n  }\n  \n  \n}\n\n.management .member .pic {\n  overflow: hidden;\n  width: 150px;\n  border-radius: 50%;\n}\n\n.management .member .pic img {\n  transition: ease-in-out 0.3s;\n}\n\n.management .member:hover img {\n  transform: scale(1.1);\n}\n\n.management .member .member-info {\n  padding-left: 30px;\n}\n\n.management .member h4 {\n  font-weight: 700;\n  margin-bottom: 5px;\n  font-size: 20px;\n  color: #2c4964;\n}\n\n.management .member span {\n  display: block;\n  font-size: 15px;\n  padding-bottom: 10px;\n  position: relative;\n  font-weight: 500;\n}\n\n.management .member span::after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 50px;\n  height: 1px;\n  background: var(--color-primary);\n  bottom: 0;\n  left: 0;\n}\n\n.management .member p {\n  margin: 10px 0 0 0;\n  font-size: 14px;\n}\n\n.management .member .social {\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.management .member .social a {\n  transition: ease-in-out 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  width: 32px;\n  height: 32px;\n  background: var(--color-primary);\n}\n\n.management .member .social a i {\n  color: #fff;\n  font-size: 16px;\n  margin: 0 2px;\n}\n\n.management .member .social a:hover {\n  background: #1977cc;\n}\n\n.management .member .social a+a {\n  margin-left: 8px;\n}\n\n\n/*About us*/\n.vision .card-body {padding-bottom:2rem}\n.vision .card-body .card-title{margin-bottom:15px;}\n\n\n.vision .card-body .card-title {\n  display: block;  \n  padding-bottom: 10px;\n  position: relative;\n  font-weight: 1000;\n}\n\n.vision .card-body .card-title::after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 50px;\n  height: 2px;\n  background: var(--color-primary);\n  bottom: 0;\n  left: 0;\n}\n\n/*--------------------------------------------------------------\n# Blog Sidebar\n--------------------------------------------------------------*/\n.blog .sidebar .sidebar-title {\n  font-size: 22px;\n  font-weight: 400;\n  padding: 0;\n  margin: 0;\n  color: var(--color-secondary);\n}\n\n.blog .sidebar .sidebar-item+.sidebar-item {\n  margin-top: 40px;\n}\n\n.blog .sidebar .search-form form {\n  background: #fff;\n  border: 1px solid rgba(27, 47, 69, 0.2);\n  padding: 3px 10px;\n  position: relative;\n}\n\n.blog .sidebar .search-form form input[type=text] {\n  border: 0;\n  padding: 4px;\n  border-radius: 4px;\n  width: calc(100% - 40px);\n}\n\n.blog .sidebar .search-form form input[type=text]:focus {\n  outline: none;\n}\n\n.blog .sidebar .search-form form button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  border: 0;\n  background: none;\n  font-size: 16px;\n  padding: 0 15px;\n  margin: -1px;\n  background: var(--color-primary);\n  color: #fff;\n  transition: 0.3s;\n  border-radius: 0 4px 4px 0;\n  line-height: 0;\n}\n\n.blog .sidebar .search-form form button i {\n  line-height: 0;\n}\n\n.blog .sidebar .search-form form button:hover {\n  background: rgba(86, 184, 230, 0.8);\n}\n\n.blog .sidebar .categories ul {\n  list-style: none;\n  padding: 0;\n}\n\n.blog .sidebar .categories ul li+li {\n  padding-top: 10px;\n}\n\n.blog .sidebar .categories ul a {\n  color: var(--color-secondary);\n  font-size: 15px;\n}\n\n.blog .sidebar .categories ul a:hover {\n  color: var(--color-default);\n}\n\n.blog .sidebar .categories ul a span {\n  padding-left: 5px;\n  color: rgba(var(--color-default-rgb), 0.4);\n  font-size: 14px;\n}\n\n.blog .sidebar .recent-posts .post-item {\n  display: flex;\n  box-shadow: 0px 0 15px rgba(0, 0, 0, 0.08);\n  padding: 20px;\n}\n\n.blog .sidebar .recent-posts .post-item+.post-item {\n  margin-top: 15px;\n}\n\n.blog .sidebar .recent-posts img {\n  width: 80px;\n  margin-right: 15px;\n}\n\n.blog .sidebar .recent-posts h4 {\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.blog .sidebar .recent-posts h4 a {\n  color: var(--color-secondary);\n  transition: 0.3s;\n}\n\n.blog .sidebar .recent-posts h4 a:hover {\n  color: var(--color-primary);\n}\n\n.blog .sidebar .recent-posts time {\n  display: block;\n  font-style: italic;\n  font-size: 14px;\n  color: rgba(var(--color-default-rgb), 0.4);\n}\n\n.blog .sidebar .tags {\n  margin-bottom: -10px;\n}\n\n.blog .sidebar .tags ul {\n  list-style: none;\n  padding: 0;\n}\n\n.blog .sidebar .tags ul li {\n  display: inline-block;\n}\n\n.blog .sidebar .tags ul a {\n  color: #38618e;\n  font-size: 14px;\n  padding: 6px 14px;\n  margin: 0 6px 8px 0;\n  border: 1px solid rgba(27, 47, 69, 0.15);\n  display: inline-block;\n  border-radius: 50px;\n  transition: 0.3s;\n}\n\n.blog .sidebar .tags ul a:hover {\n  color: #fff;\n  border: 1px solid var(--color-primary);\n  background: var(--color-primary);\n}\n\n.blog .sidebar .tags ul a span {\n  padding-left: 5px;\n  color: rgba(27, 47, 69, 0.8);\n  font-size: 14px;\n}\n\n/*--------------------------------------------------------------\n# Blog Comments\n--------------------------------------------------------------*/\n.blog .comments {\n  margin-top: 30px;\n}\n\n.blog .comments .comments-count {\n  font-weight: bold;\n}\n\n.blog .comments .comment {\n  margin-top: 30px;\n  position: relative;\n}\n\n.blog .comments .comment .comment-img {\n  margin-right: 14px;\n}\n\n.blog .comments .comment .comment-img img {\n  width: 60px;\n}\n\n.blog .comments .comment h5 {\n  font-size: 16px;\n  margin-bottom: 2px;\n}\n\n.blog .comments .comment h5 a {\n  font-weight: bold;\n  color: var(--color-default);\n  transition: 0.3s;\n}\n\n.blog .comments .comment h5 a:hover {\n  color: var(--color-primary);\n}\n\n.blog .comments .comment h5 .reply {\n  padding-left: 10px;\n  color: var(--color-secondary);\n}\n\n.blog .comments .comment h5 .reply i {\n  font-size: 20px;\n}\n\n.blog .comments .comment time {\n  display: block;\n  font-size: 14px;\n  color: rgba(27, 47, 69, 0.8);\n  margin-bottom: 5px;\n}\n\n.blog .comments .comment.comment-reply {\n  padding-left: 40px;\n}\n\n.blog .comments .reply-form {\n  margin-top: 30px;\n  padding: 30px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.blog .comments .reply-form h4 {\n  font-weight: bold;\n  font-size: 22px;\n}\n\n.blog .comments .reply-form p {\n  font-size: 14px;\n}\n\n.blog .comments .reply-form input {\n  border-radius: 4px;\n  padding: 10px 10px;\n  font-size: 14px;\n}\n\n.blog .comments .reply-form input:focus {\n  box-shadow: none;\n  border-color: rgba(86, 184, 230, 0.8);\n}\n\n.blog .comments .reply-form textarea {\n  border-radius: 4px;\n  padding: 10px 10px;\n  font-size: 14px;\n}\n\n.blog .comments .reply-form textarea:focus {\n  box-shadow: none;\n  border-color: rgba(86, 184, 230, 0.8);\n}\n\n.blog .comments .reply-form .form-group {\n  margin-bottom: 25px;\n}\n\n.blog .comments .reply-form .btn-primary {\n  border-radius: 4px;\n  padding: 10px 20px;\n  border: 0;\n  background-color: var(--color-secondary);\n}\n\n.blog .comments .reply-form .btn-primary:hover {\n  background-color: rgba(27, 47, 69, 0.8);\n}\n\n/*--------------------------------------------------------------\n# Blog Home Pagination\n--------------------------------------------------------------*/\n.blog .blog-pagination {\n  margin-top: 30px;\n  color: #38618e;\n}\n\n.blog .blog-pagination ul {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.blog .blog-pagination li {\n  margin: 0 5px;\n  transition: 0.3s;\n}\n\n.blog .blog-pagination li a {\n  color: #2aa5df;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  background: #dbf0fa;\n  padding: 7px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.blog .blog-pagination li.active a,\n.blog .blog-pagination li:hover a {\n  background: var(--color-primary);\n  color: #fff;\n}\n\n/*--------------------------------------------------------------\n# Counts\n--------------------------------------------------------------*/\n.counts {\n  padding-top: 80px;\n}\n\n.counts .count-box {\n  padding: 30px 30px 25px 30px;\n  width: 100%;\n  position: relative;\n  text-align: center;\n  box-shadow: 0px 2px 35px rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n}\n\n.counts .count-box i {\n  position: absolute;\n  width: 54px;\n  height: 54px;\n  top: -27px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 24px;\n  background: #fff;\n  color: #e03a3c;\n  border-radius: 50px;\n  border: 2px solid #fff;\n  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.1);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.counts .count-box span {\n  font-size: 36px;\n  display: block;\n  font-weight: 700;\n  color: #111111;\n}\n\n.counts .count-box p {\n  padding: 0;\n  margin: 0;\n  font-family: \"Raleway\", sans-serif;\n  font-size: 14px;\n}\n\n/*--------------------------------------------------------------\n# Clients Section\n--------------------------------------------------------------*/\n.clients {\n  padding: 0 0 60px 0;\n  /*background: var(--light-2);*/\n   background: var(--white);\n}\n\n.clients .swiper-slide img {\n  /*opacity: 0.5;*/\n  transition: 0.3s;\n  /*filter: grayscale(100); */\n\n  background-color: var(--white);\npadding:10px;  \n  \n  border-radius: 8px;\n  -webkit-transition: all 0.4s ease-out 0s;\n  -moz-transition: all 0.4s ease-out 0s;\n  -ms-transition: all 0.4s ease-out 0s;\n  -o-transition: all 0.4s ease-out 0s;\n  transition: all 0.4s ease-out 0s;\n  border: 1px solid #eee;\n}\n\n\n\n\n\n.clients .swiper-slide img:hover {\n   box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.096);\n  -webkit-transform: translateY(-5px);\n  -moz-transform: translateY(-5px);\n  -ms-transform: translateY(-5px);\n  -o-transform: translateY(-5px);\n  transform: translateY(-5px);\n}\n/*--------------------------------------------------------------\n# Footer\n--------------------------------------------------------------*/\n.footer {\n  font-size: 14px;\n}\n\n.footer .footer-content {\n  background-color: var (--white);\n  background-size: contain;\n  padding: 60px 0 30px 0;\n}\n\n.footer .footer-content .footer-info {\n  margin-bottom: 30px;\n}\n\n.footer .footer-content .footer-info .logo {\n  line-height: 0;\n  margin-bottom: 10px;\n}\n\n.footer .footer-content .footer-info .logo img {\n  /*max-height: 40px;*/\n   max-width: 140px;\n  margin-right: 6px;\n}\n\n.footer .footer-content .footer-info .logo span {\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: var(--color-secondary);\n  font-family: var(--font-secondary);\n  margin-top: 3px;\n}\n\n.footer .footer-content .footer-info p {\n  /* font-size: 15px; */\n  font-size: 14px;\n  margin-bottom: 0;\n  font-family: var(--font-primary);\n  color: var(--color-secondary);\n}\n\n.footer .footer-content .social-links a {\n  font-size: 14px;\n  line-height: 0;\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n  color: rgba(27, 47, 69, 0.5);\n  margin-right: 10px;\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--color-primary);\n  color: #fff;\n  border-radius: 50px;\n}\n\n.footer .footer-content .social-links a:hover {\n  background-color: #38618e;\n}\n\n.footer .footer-content h4 {\n  font-size: 16px;\n  font-weight: bold;\n  color: var(--black);\n  position: relative;\n  padding-bottom: 12px;\n}\n\n.footer .footer-content .footer-links {\n  margin-bottom: 30px;\n}\n\n.footer .footer-content .footer-links ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer .footer-content .footer-links ul i {\n  margin-right: 2px;\n  color: var(--color-primary);\n  font-size: 16px;\n  line-height: 0;\n}\n\n.footer .footer-content .footer-links ul li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n}\n\n.footer .footer-content .footer-links ul li:first-child {\n  padding-top: 0;\n}\n\n.footer .footer-content .footer-links ul a {\n  color: var(--dark-3);\n  transition: 0.3s;\n  display: inline-block;\n  line-height: 1;\n\n}\n\n.footer .footer-content .footer-links ul a:hover {\n  color: var(--color-primary);\n}\n\n.footer .footer-content .footer-contact p {\n  line-height: 26px;\n  color: var(--dark-3);\n}\n\n.footer .footer-legal {\n background: var(--light-2);\n  padding: 30px 0;\n}\n\n.footer .footer-legal .copyright {\n  text-align: center;\n  color:  var(--dark-3);\n}\n\n.footer .footer-legal .credits {\n  padding-top: 4px;\n  text-align: center;\n  font-size: 13px;\n  color:  var(--dark-3);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
